/*
  #ANCHOR Imports
*/ 

import { oxgGenerateUniqueId, oxgIdIsUnique } from "../../modules/generate-unique-id"
import { oxgOpenModal, oxgCloseModal, oxgFetchModal, oxgCloseModalAnimated, oxgCreateLoadingOverlay, oxgRemoveLoadingOverlay, oxgCreateNewModalEntity } from "../../modules/modals"
import { oxgIncrementNumberAtStringEnd } from "../../modules/increment-number"
import { oxgGetLang, oxgLangDeOrEn } from "../../modules/get-lang"
import { oxgGetDaysUntil } from "../../modules/date-functions"
import { oxgGetTodayPlusDays } from "../../modules/date-functions"
import { oxgCreateUf } from "../../modules/user-feedback"
import { oxgRemoveUfsFromContainer } from "../../modules/user-feedback"
import { oxgScrollToChild } from "../../modules/scroll-functions"
import { oxgReplaceUrlParametersInString, oxgIsStringPageAmountPrintable, oxgIsValidEmail, oxgAutoCorrectPhoneNumber, oxgExtractPriceFromString } from "../../modules/strings"
import "../../modules/sidebar-toggle"
import datepicker from 'js-datepicker';
import { prevent } from "@splidejs/splide/src/js/utils"
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { oxgAssetBriefingPriceEst } from "../modules/asset-briefing-price-estimation.js";

var oxgModalsHistory = [];
var oxgAssetBriefingPage = 1;

/*
  #SECTION New Briefing Form
*/ 

/*
  #ANCHOR New
*/

export function oxgCleanUpAbSessionItems() {
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key.endsWith('-modal') || key.endsWith('-sidebar-item') || key == 'oxgAssetBriefingItems' || key == 'oxgAssetBriefingMeta' || key == 'oxgAssetBriefingCurrentSave') {
      sessionStorage.removeItem(key);
      // Since an item is removed, adjust the index and length
      i--; 
    }
  }
}

window.oxgNewAssetBriefing = (skipOverrideCheck = false)=> {
  if( (oxgAssetBriefingCurrentSave.unsavedChanges && !skipOverrideCheck) || (oxgAssetBriefingCurrentSave.isActive && !skipOverrideCheck) ) {
    let ducnmModal = oxgFetchModal('ducnm')
    console.log(ducnmModal)
    oxgOpenModal(ducnmModal, 'compact')
  } else {
    //sessionStorage.removeItem('oxgAssetBriefingItems')
    //sessionStorage.removeItem('oxgAssetBriefingMeta')
    //sessionStorage.removeItem('oxgAssetBriefingCurrentSave')
    oxgCleanUpAbSessionItems()
    if(oxgAssetBriefingPage == 1) {
      window.location.reload();
    } else {
      window.open(window.location.origin + '/asset-briefing', '_self')
    }
  }
  
}

/*
  #SECTION Save
*/ 

const setSublineInfoLineCurrentBriefing = ()=> {
  let deEn = getDeEn()
  let subline = getPageSubline()
  let infoline = getPageInfoline()
  subline.innerHTML = deEn == 'de' ? 'Bearbeite <span class="tc-primary">"' + oxgAssetBriefingCurrentSave.saveName + '"</span>' : 'Editing <span class="tc-primary">"' + oxgAssetBriefingCurrentSave.saveName + '"</span>'
  oxgAssetBriefingPage == 1 ? infoline.innerHTML = deEn == 'de' ? 'Du willst neu anfangen? Beginne ein neues Briefing, indem du "Neu <span class="icon-32-copy inline-icon"></span>" klickst.' : 'Want to start fresh? Start a new briefing by clicking "New <span class="icon-32-copy inline-icon"></span>".' : null
}

const setSublineInfoLineContinueWork = ()=> {
  let deEn = getDeEn()
  let subline = getPageSubline()
  let infoline = getPageInfoline()
  subline.innerHTML = ''
  infoline.innerHTML = ''
  let startNewBriefingLink = document.createElement('a')
  startNewBriefingLink.classList.add('discard-session-link')
  startNewBriefingLink.setAttribute('onClick', 'event.preventDefault(); oxgNewAssetBriefing(this);')
  startNewBriefingLink.innerText = deEn == 'de' ? 'Zwischenspeicher verwerfen' : 'Discard your current session'
  let infoTextSpan = document.createElement('span')
  infoTextSpan.innerText = deEn == 'de' ? 'Du willst von Vorne beginnen? ' : 'Want to start over? '
  infoline.appendChild(infoTextSpan)
  infoline.appendChild(startNewBriefingLink)
  subline.innerText = deEn == 'de' ? 'Fahre mit deiner Arbeit fort' : 'Continue with your work'
}

/*
  #ANCHOR Save
*/

window.oxgSaveAssetBriefing = (modalId)=> {
  let saveNameField = document.getElementById('oxg-field-briefing-save-name')
  let teamIdFieldModal = document.getElementById('oxg-menu-briefing-team-id')
  let assetBriefingField = document.getElementById('briefing-assets')
  let uf
  let name = saveNameField && saveNameField.tagName == 'INPUT' && saveNameField.value.trim().length > 0 ? saveNameField.value : null
  let content = {assets: oxgAssetBriefingItems, main: oxgAssetBriefingMeta}
  let teamId = teamIdFieldModal && teamIdFieldModal.tagName == 'SELECT' && teamIdFieldModal.value ? teamIdFieldModal.value : null
  let responseContainer = saveNameField.parentNode.querySelector('.field-response-container')
  let responseContainerTeam = teamIdFieldModal ? teamIdFieldModal.parentNode.querySelector('.field-response-container') : null

  let doSave = ((name && teamIdFieldModal && teamIdFieldModal.value) || (name && !teamIdFieldModal)) ? true : false;

  if (teamIdFieldModal && !teamIdFieldModal.value) {
    // Multiple Team ID options available but none selected
    // Happens if user is in more than one team
    doSave = false;
    oxgRemoveUfsFromContainer(responseContainerTeam)
    uf = oxgCreateUf({
      format: 'text',
      icon: 'exclamation-mark--circled',
      style: 'danger',
      message: 'Chose a team',
      messageDe: 'Wähle einen Team',
      container: responseContainerTeam,
      classes: ['omit-m-top', 'm-s-bottom'],
      return: true,
    })
  } else if (responseContainerTeam) {
    oxgRemoveUfsFromContainer(responseContainerTeam)
  }

  if(!name) {
    // No Save Name provided
    doSave = false;
    oxgRemoveUfsFromContainer(responseContainer)
    uf = oxgCreateUf({
      format: 'text',
      icon: 'exclamation-mark--circled',
      style: 'danger',
      message: 'Chose a name',
      messageDe: 'Wähle einen Namen',
      container: responseContainer,
      classes: ['omit-m-top', 'm-s-bottom'],
      return: true,
    })
  } else {
    oxgRemoveUfsFromContainer(responseContainer)
  }

  if (doSave) {
    var dataToSave = {
      saveName: name,
      teamId: teamId, 
      //contentAssets: contentAssets,
      //contentMain: contentMain,
      content: JSON.stringify(content),
      overwrite: modalId == 'obm' || name == oxgAssetBriefingCurrentSave.saveName ? true : false,
    }

    oxgCreateLoadingOverlay()

    jQuery.ajax({
      url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint (available in the admin context or frontend if localized)
      type: 'POST',
      data: {
          action: 'oxg_save_asset_briefing', // WordPress action hook to trigger the PHP function
          data: dataToSave
      },
      success: function(response) { 
        oxgRemoveLoadingOverlay()
        if (response.data.message == 'already_exists') {
          let obmModal = oxgFetchModal('obm')
          oxgCloseModal(modalId)
          oxgOpenModal(obmModal, 'compact', 'oxgAfterOverwriteBriefingModalOpen', {name: name, teamId: teamId})
        } else if (response.data.message == 'saved') {
          //updateSaveInterface({showSaveDraftAsBtn: false, showSaveDraftBtn: true, showNewBriefingBtn: true, showUnsavedChangesInfo: false, showSavedInfoline: true})
          let ssdmModal = oxgFetchModal('ssdm')
          oxgCloseModal(modalId)
          oxgOpenModal(ssdmModal, 'compact', 'oxgAfterSaveSuccessfulModalOpen')
          updateOxgAssetBriefingCurrentSave({isActive: true, saveName: name, oxgId: response.data.oxgId, unsavedChanges: false, teamId: response.data.teamId, updateSessionItem: true})
          setSublineInfoLineCurrentBriefing()
        } else if (response.data.message == 'failed' || response.data.message == 'no_data') {
          let sfdmModal = oxgFetchModal('sfdm')
          oxgCloseModal(modalId)
          oxgOpenModal(sfdmModal, 'compact')
        }
      },
      error: function(xhr, status, error) { 
        console.error('Error saving data:', error)
        let sfdmModal = oxgFetchModal('sfdm')
        oxgCloseModal(modalId)
        oxgOpenModal(sfdmModal, 'compact')
      }
    });

  }
}

/*
  #ANCHOR Get User Teams
*/

const getUserTeams = ()=> {
  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint (available in the admin context or frontend if localized)
    type: 'POST',
    data: {
        action: 'oxg_get_user_teams', // WordPress action hook to trigger the PHP function
        data: 'no data'
    },
    success: function(response) { 
      console.log(response); 
      return response
    },
    error: function(xhr, status, error) { 
      console.error('Error sending request', error); 
      return null
    }
  });
}

/*
  #ANCHOR After Save Modal Open
*/

window.oxgAfterSaveBriefingModalOpen = ()=> {
  let title = document.getElementById('briefing-title')
  let saveName = document.getElementById('oxg-field-briefing-save-name')
  let teamId = document.getElementById('briefing-team-id')
  let modalTeamId = document.getElementById('oxg-menu-briefing-team-id')
  if (teamId && teamId.value) {
    modalTeamId.value = teamId.value
  } else if ( oxgAssetBriefingMeta.hasOwnProperty('team_id') && oxgAssetBriefingMeta.team_id ) {
    modalTeamId.value = oxgAssetBriefingMeta.team_id
  }
  let saveNameValue
  if (saveName && saveName.tagName == 'INPUT' && !saveName.value) {
    if (oxgAssetBriefingCurrentSave.isActive && oxgAssetBriefingCurrentSave.saveName ) {
      saveNameValue = oxgAssetBriefingCurrentSave.saveName
    } else {
      saveNameValue = title.value
    }
    let length = saveNameValue.length
    saveName.value = saveNameValue
    saveName.setSelectionRange(length, length)
  }
}

/*
  #ANCHOR After Save Successful
*/

window.oxgAfterSaveSuccessfulModalOpen = ()=> {
  setTimeout(function() {
    window.location.reload();
  }, 400)
}

/*
  #ANCHOR After Overwrite Modal Open
*/

window.oxgAfterOverwriteBriefingModalOpen = (options)=> {
  console.log('oxgAfterOverwriteBriefingModalOpen', options)
  if(options.name) {
    document.getElementById('oxg-modal-obm-title').innerText = options.name
    document.getElementById('oxg-field-briefing-save-name').value = options.name
  }
  if(options.teamId) {
    document.getElementById('oxg-menu-briefing-team-id').value = options.teamId
  }
}

//#!SECTION

/*
  #SECTION Session
*/ 

/*
  #ANCHOR Continue Session
*/

const oxgContinueSession = ()=> {

  let subline = getPageSubline()
  let infoline = getPageInfoline()
  let deEn = getDeEn()

  // Get Items
  let itemsInSession = sessionStorage.getItem('oxgAssetBriefingItems') 
  let sessionItems = JSON.parse(itemsInSession)

  // Get Meta Infos
  let metaInSession = sessionStorage.getItem('oxgAssetBriefingMeta')
  let sessionMeta = null
  if (metaInSession) {
    sessionMeta = JSON.parse(metaInSession)
    oxgAssetBriefingMeta = sessionMeta
  }

  // Get Current Save Info
  let currentSave = getCurrentSaveInfoFromSession()
  if (currentSave) {
    updateOxgAssetBriefingCurrentSaveFromSession()
  }

  //Set Subline
  if ( metaInSession || sessionItems ) {
    if (typeof currentSave !== 'undefined' && currentSave.isActive) {
      setSublineInfoLineCurrentBriefing()
    } else if ( oxgAssetBriefingPage == 1) {
      setSublineInfoLineContinueWork()
    }
  }

  // No Session: Create Sidebar User Feedback Message
  if ( !itemsInSession && !metaInSession ) {
    let container = document.querySelector('.sidebar-feed-response')
    oxgRemoveUfsFromContainer(container)
    oxgCreateUf({
      format: 'box',
      icon: 'exclamation-mark--circled',
      style: 'info',
      message: 'Add one or more assets to this briefing.',
      messageDe: 'Füge mindestens ein Asset zu diesem Briefing hinzu.',
      container: container,
      classes: ['omit-m-top', 'm-xxs-bottom'],
      return: true,
    })
    return
  }

  // Get sidebar if page 1
  const sidebar = oxgAssetBriefingPage == 1 ? document.getElementById('oxg-sidebar') : null
  let sidebarMain = oxgAssetBriefingPage == 1 ? sidebar.querySelector('.main') : null

  // Get title, deadline, substitute
  let titleValue, deadlineValue, briefingCommentValue, briefingDeadlineValue, briefingTitleValue, briefingSubstituteNameValue, briefingSubstituteEmailValue, briefingSubstitutePhoneValue, briefingTeamIdValue
  let briefingTitle, briefingDeadline, briefingComment, briefingSubstituteName, briefingSubstitutePhone, briefingSubstituteEmail, briefingTeamId
  if ( sessionMeta ) {
    // Get Fields
    briefingTitle = oxgAssetBriefingPage == 1 ? sidebar.querySelector('#briefing-title') : document.getElementById('briefing-title')
    briefingDeadline = oxgAssetBriefingPage == 1 ? sidebar.querySelector('#briefing-deadline') : document.getElementById('briefing-deadline')
    briefingComment = oxgAssetBriefingPage == 2 ? document.getElementById('briefing-main-description') : null
    briefingSubstituteName = oxgAssetBriefingPage == 2 ? document.getElementById('substitute-name') : null
    briefingSubstituteEmail = oxgAssetBriefingPage == 2 ? document.getElementById('substitute-email') : null
    briefingSubstitutePhone = oxgAssetBriefingPage == 2 ? document.getElementById('substitute-phone') : null
    briefingTeamId = oxgAssetBriefingPage == 2 ? document.getElementById('briefing-team-id') : null
    // Set Title
    briefingTitle.value = sessionMeta.title // Input Field
    briefingTitleValue = sessionMeta.title
    // Set Comment
    briefingCommentValue = sessionMeta.comment
    briefingComment = sessionMeta.comment // Input Field
    // Set Substitute
    briefingSubstituteNameValue = sessionMeta.hasOwnProperty('substitute_name') ? sessionMeta.substitute_name : null
    if (briefingSubstituteEmail) { briefingSubstituteName.value = sessionMeta.hasOwnProperty('substitute_name') ? sessionMeta.substitute_name : null } // Input Field
    briefingSubstituteEmailValue = sessionMeta.hasOwnProperty('substitute_email') ? sessionMeta.substitute_email : null
    if (briefingSubstituteEmail) { briefingSubstituteEmail.value = sessionMeta.hasOwnProperty('substitute_email') ? sessionMeta.substitute_email : null } // Input Field
    briefingSubstitutePhoneValue = sessionMeta.hasOwnProperty('substitute_phone') ? sessionMeta.substitute_phone : null
    if (briefingSubstitutePhone) { briefingSubstitutePhone.value = sessionMeta.hasOwnProperty('substitute_phone') ? sessionMeta.substitute_phone : null } // Input Field
    titleValue = sessionMeta.hasOwnProperty('title') ? sessionMeta.title : null
    // Set Team ID
    if ( briefingTeamId ) { briefingTeamId.value = sessionMeta.hasOwnProperty('team_id') ? sessionMeta.team_id : briefingTeamId.value } // Input Field
    briefingTeamIdValue = sessionMeta.hasOwnProperty('team_id') ? sessionMeta.team_id : null;
    // Check & Set Deadline
    let deadlineStatus
    if( sessionMeta.deadline ) {
      deadlineStatus = oxgCheckBriefingDeadline(sessionMeta.deadline)
    }
    let deadlineResponseContainer = briefingDeadline.parentNode.querySelector('.field-response-container')
    let removeLink = deadlineResponseContainer.querySelector('.remove-deadline-link')
    if (deadlineStatus == 'warning') {
      briefingDeadline.value = sessionMeta.deadline // Input Field
      briefingDeadlineValue = sessionMeta.deadline
      //updateAndSync(briefingDeadline.value, 'deadline', false)
      updateSessionMeta('deadline', briefingDeadline.value)
      oxgRemoveUfsFromContainer(deadlineResponseContainer)
      oxgCreateUf({
        format: 'text',
        icon: 'exclamation-mark--circled',
        style: 'info',
        message: 'This is short notice but we will do our best! Additional costs or delays may encure. You can continue.',
        messageDe: 'Das ist etwas kurzfristig aber wir geben unser Bestes! Zusätzliche Kosten oder Verzögerungen könnten entstehen. Du kannst weitermachen.',
        container: deadlineResponseContainer,
        classes: ['m-xs-top'],
        return: true,
      })
      if(removeLink) { removeLink.classList.remove('is-hidden') }
    } else if(deadlineStatus == 'optimal') {
      briefingDeadline.value = sessionMeta.deadline
      briefingDeadlineValue = sessionMeta.deadline
      deadlineValue = sessionMeta.title
      if(removeLink) { removeLink.classList.remove('is-hidden') }
    } // END Deadline check
  } // END Get title and deadline

  // Remove sidebar empty message
  if(sessionItems && sessionItems.length > 0 && oxgAssetBriefingPage == 1) {
    let assetBriefingFeedEmpty = document.getElementById('briefing-feed-empty-container')
    //dispatch event
    let event = new Event('oxgAssetRestoredToSidebarFromSession')
    document.dispatchEvent(event)
  }

  if(oxgAssetBriefingPage == 2) {
    syncBriefingForm()
  }

  //populate sidebar & modals
  let notAssets = ['deadline', 'comment', 'description', 'title']
  if(oxgAssetBriefingPage == 1 && sessionItems) {
    sessionItems.forEach(item => {
      console.log('Session Item: ', item)
      let isNotAsset = notAssets.some(key => key in item);
      if(isNotAsset) { console.log('skipping this, as it is not an asset') } else {

        let cartItemId = item.cartItemId

        // Modal
        console.log('trying to retrieve modal from session. Cart Item ID: ', cartItemId)
        let modal = sessionStorage.getItem(cartItemId + '-modal')
        if(modal) {
          console.log('modal exists in session data')
          let tempModalContainer = document.createElement('div')
          tempModalContainer.innerHTML = modal
          item.modal = tempModalContainer.firstElementChild
          //console.log('modal was found', modal, typeof modal)
        } else {
          console.log('No modal was found in session data. Likely cause the briefing was loaded from database')
          
          //create new modal entity
          let modalId = item.modalId
          let modalData = oxgFetchModal(modalId)
          modal = oxgCreateNewModalEntity(modalId, null, null, null, null, modalData)
          modal.setAttribute('data-cart-item-id', cartItemId)
          
          //update item.modal with entity
          item.modal = modal

        } // END Modal

        // Sidebar Item
        let sidebarItem = sessionStorage.getItem(cartItemId + '-sidebar-item')
        if(sidebarItem) {
          if (sidebarMain) {
            let tempSidebarItemContainer = document.createElement('div')
            if(tempSidebarItemContainer) {
              tempSidebarItemContainer.innerHTML = sidebarItem;
              item.sidebarItem = tempSidebarItemContainer.firstElementChild
              sidebarMain.appendChild(tempSidebarItemContainer.firstElementChild)
            }
          }
        } else {
          let sidebarItemData = createSidebarItemDataFromStorage(item)
          let cartItemId = item.cartItemId
          let sidebarItem = createNewSidebarItem(sidebarItemData)
          let sidebarMain = sidebar.querySelector('.main')
          sidebarMain.appendChild(sidebarItem)
          item.sidebarItem = sidebarItem
          let sidebarItemClone = sidebarItem.cloneNode(true)
          sessionStorage.setItem(cartItemId + '-sidebar-item', sidebarItemClone.outerHTML)
        }// END Sidebar Item

      } // END is an Asset

      // Update and Sync
      oxgAssetBriefingItems.push(item)
      syncBriefingForm()

    }) // END for each session item
  // END If page 1 loop session items
  } else if (oxgAssetBriefingPage == 2) {
    oxgAssetBriefingItems = JSON.parse(sessionStorage.getItem('oxgAssetBriefingItems'))
  }

  updateSessionMeta('deadline', briefingDeadlineValue)
  updateSessionMeta('title', briefingTitleValue)
  updateSessionMeta('comment', briefingCommentValue)
  updateSessionMeta('substitute_name', briefingSubstituteNameValue)
  updateSessionMeta('substitute_email', briefingSubstituteEmailValue)
  updateSessionMeta('substitute_phone', briefingSubstitutePhoneValue)
  updateSessionMeta('team_id', briefingTeamIdValue)
}

/*
  #ANCHOR Remove Item from Session Storage
*/ 

const removeItemFromSessionStorage = (cartItemId) => {
  let itemsInSession = sessionStorage.getItem('oxgAssetBriefingItems')
  if( !itemsInSession ) return
  let sessionItems = JSON.parse(itemsInSession)
  sessionStorage.removeItem(cartItemId + '-sidebar-item')
  sessionStorage.removeItem(cartItemId + '-modal')
  sessionItems = sessionItems.filter((item) => cartItemId !== item['cartItemId'])
  sessionStorage.setItem('oxgAssetBriefingItems', JSON.stringify(sessionItems))
}

//#!SECTION

/*
  #SECTION Modal
*/ 

/*
  #ANCHOR Modal Open
*/ 

document.addEventListener('oxgModalOpen', ()=> {
  let modals = document.querySelectorAll('.oxg-modal')
  Array.from(modals).forEach(modal => {
    let id = modal.getAttribute('data-modal-id')

    //register if necessary
    let registered = false
    console.log('oxgModalsHistory', oxgModalsHistory)
    oxgModalsHistory.every(oxgModal => {
      let oxgId = oxgModal.getAttribute('data-modal-id')
      if (oxgId != id) {
        return true
      } else {
        registered = true
        return false
      }
    })
    if(!registered) {
      oxgModalsHistory.push(modal)
    }

    //focus name field
    let field = modal.querySelector('.focus-on-modal-open')
    if(field) {
      let length = field.value.length;
      field.focus()
      field.setSelectionRange(length, length)
    }

    //init modal
    if(oxgAssetBriefingPage == 1) {
      let modalType = getModalType(modal)
      if ( modalType == 'asset-specs') {
        oxgListenForDateChange(modal)
        oxgAddModalFieldEventListeners(modal)
        oxgAddModalFieldEventListeners2(modal)
        oxgIncrementNameMaybe(modal)
        oxgUpdateModalAssetPrice(modal)
        oxgMaybeRestorePagesFieldConfig(modal)
      }
    }
    
  })
})

/*
  #ANCHOR Get Modal Type
*/

const getModalType = (modal) => {
  let id = modal.getAttribute('data-modal-id')
  if(!id) {
    console.error('no modal id found for given modal', modal)
    return
  }
  let modalData = oxgModalsData[id]
  if(!modalData) {
    console.error('no modal data for id: ' + id)
    return
  }
  let type = modalData['type']
  if (!type) {
    console.error('Given modal has no key named "type". Check modal id in oxgModalsData', id)
    return
  }
  if (typeof type != 'string') {
    console.error('Value for key "type" in oxgModalsData is not of type "string" for given id.', id)
    return
  }
  return type
}

/*
  #ANCHOR Show Hide Format Text Field
*/

window.oxgShowHideFormatTextField = (container) => {
  let checkbox = container.querySelector('input[type=checkbox]')
  let textContainer = document.getElementById(container.getAttribute('data-target'))
  let userFeedbackMessage = document.getElementById(container.getAttribute('data-target-uf'))
  let inputField = textContainer.querySelector('input[type=text]')
  if (!checkbox || !textContainer || !inputField) return
  if (checkbox.checked) {
    textContainer.classList.add('is-hidden')
    userFeedbackMessage.classList.remove('is-hidden')
    inputField = textContainer.querySelector('input[type=text]')
    inputField.required = false
    inputField.setAttribute('data-is-inactive', 'true')
  } else {
    textContainer.classList.remove('is-hidden')
    userFeedbackMessage.classList.add('is-hidden')
    inputField = textContainer.querySelector('input[type=text]')
    inputField.setAttribute('data-is-inactive', 'false')
    inputField.required = true
  }
}

/*
  #ANCHOR Maybe Update Pages Override
*/

const oxgMaybeRestorePagesFieldConfig = (modal) => {
  console.log('cartItemId', modal.getAttribute('data-cart-item-id'))
  let pageNumbersField = modal.querySelector('.field-page-numbers')
  if(pageNumbersField) {
    let isActive = pageNumbersField.getAttribute('data-is-inactive') == 'false' ? true : false;
    if (isActive) {
      let pageNumbersFieldId = pageNumbersField.getAttribute('id')
      console.log('pageNumbersFieldId', pageNumbersFieldId)
    }
  }
  let pagesOverride = modal.querySelector('.field-override-pages')
  if(pagesOverride) {
    oxgShowHidePagesField(pagesOverride.parentNode)
  }
} 

/*
  #ANCHOR Show Hide Pages Options
*/

window.oxgShowHidePagesField = (container) => {
  let checkbox = container.querySelector('input[type=checkbox]')
  let pagesInputContainer = document.getElementById(container.getAttribute('data-target'))
  let userFeedbackMessage = document.getElementById(container.getAttribute('data-target-uf'))
  let inputField = pagesInputContainer.querySelector('input[type=text], input[type=number]')
  let hiddenField = pagesInputContainer.querySelector('input[type="hidden"][data-option-name="pages"]')
  let modalId = container.getAttribute('data-modal-id')
  let modals = document.querySelectorAll('.oxg-modal')
  let modal = null
  Array.from(modals).forEach(thisModal => {
    let id = thisModal.getAttribute('data-modal-id')
    if (id == modalId) {
      modal = thisModal
    }
  })
  let radioButtons = pagesInputContainer.querySelectorAll('input[type=radio]')
  radioButtons = Array.from(radioButtons)
  if (!checkbox || !pagesInputContainer ) return
  if (checkbox.checked) {
    userFeedbackMessage.classList.remove('is-hidden')
    pagesInputContainer.classList.add('is-hidden')
    if (inputField) {
      hiddenField.value = null
      hiddenField.setAttribute('data-is-inactive', 'true')
      inputField.value = null
      inputField.required = false
      inputField.setAttribute('data-is-inactive', 'true')
      oxgUpdateModalAssetPrice(modal)
    } else if (radioButtons) {
      radioButtons.forEach(radioButton => {
        radioButton.required = false
        radioButton.setAttribute('data-is-inactive', 'true')
      })
    }
  } else {
    oxgUpdateModalAssetPrice(modal)
    userFeedbackMessage.classList.add('is-hidden')
    pagesInputContainer.classList.remove('is-hidden')
    if (inputField) {
      hiddenField.setAttribute('data-is-inactive', 'false')
      inputField.setAttribute('data-is-inactive', 'false')
      inputField.required = true
    } else if (radioButtons) {
      radioButtons.forEach(radioButton => {
        radioButton.required = true
        radioButton.setAttribute('data-is-inactive', 'false')
      })
    }
  }
}

/*
  #ANCHOR Show Hide Languages Text Field
*/

window.oxgShowHideLanguagesTextField = (container) => {
  let checkbox = container.querySelector('input[type=checkbox]')
  let textContainer = document.getElementById(container.getAttribute('data-target'))
  let inputField = textContainer.querySelector('input[type=text]')
  if (!checkbox || !textContainer || !inputField) return
  if (!checkbox.checked) {
    textContainer.classList.add('is-hidden')
    inputField = textContainer.querySelector('input[type=text]')
    inputField.setAttribute('data-is-inactive', 'true')
    inputField.removeAttribute('required')
  } else {
    textContainer.classList.remove('is-hidden')
    inputField = textContainer.querySelector('input[type=text]')
    inputField.setAttribute('data-is-inactive', 'false')
    inputField.setAttribute('required', null)
    //inputField.required = true
  }
}

window.oxgShowHideReferenceProjectTextField = (container) => {
  let radioButtons = container.querySelectorAll('input[type=radio]')
  let textContainer = document.getElementById(container.getAttribute('data-target'))
  let inputField = textContainer.querySelector('input[type=text]')
  if (!radioButtons || !textContainer || !inputField) return
  Array.from(radioButtons).forEach(radioButton => {
    console.log('radioButton', radioButton)
    if (radioButton.checked) {
      console.log('is checked')
      if(radioButton.value == 'Adaptation' || radioButton.value == 'Hybrid') {
        textContainer.classList.remove('is-hidden')
        inputField.setAttribute('data-is-inactive', 'false')
        inputField.setAttribute('required', null)
      } else {
        textContainer.classList.add('is-hidden')
        inputField.setAttribute('data-is-inactive', 'true')
        inputField.removeAttribute('required')
      }
    }
  })
}

/*
  #ANCHOR Show Hide Open Data Fee
*/

window.oxgShowHideOpenDataDeliveryFeeInfo = (container) => {
  /*let checkbox = container.querySelector('input[type=checkbox]')
  let infoContainer = document.getElementById(container.getAttribute('data-target'))
  if (!checkbox.checked) {
    infoContainer.classList.add('is-hidden')
  } else {
    infoContainer.classList.remove('is-hidden')
  }*/
}


/*
  #ANCHOR Show Fieldset
*/

window.oxgShowAssetFieldset = (button)=> {
  let modalId = button.getAttribute('data-modal-id')
  let target = button.getAttribute('data-target')
  let modal = getModalFromId(modalId)
  let modalMenuButtons = modal.querySelectorAll('.modal-menu-button')
  let removeButton = null
  Array.from(modalMenuButtons).every(button => {
    let buttonFunction = button.getAttribute('data-function')
    let buttonTarget = button.getAttribute('data-target')
    if (buttonFunction == 'hide' && buttonTarget == target) {
      removeButton = button
      return false
    }
    return true
  })
  let fieldset = modal.querySelector('.' + target)
  let fieldsInFieldset = fieldset.querySelectorAll('input')
  if (fieldsInFieldset.length == 0) { fieldsInFieldset = fieldset.querySelectorAll('textarea') }
  fieldsInFieldset.forEach(field => {
    field.setAttribute('data-is-inactive', 'false')
  })
  fieldset.classList.remove('is-hidden')
  button.classList.add('is-hidden')
  removeButton.classList.remove('is-hidden')
}

/*
  #ANCHOR Hide Fieldset
*/

window.oxgHideAssetFieldset = (button)=> {
  let modalId = button.getAttribute('data-modal-id')
  let target = button.getAttribute('data-target')
  let modal = getModalFromId(modalId)
  let modalMenuButtons = modal.querySelectorAll('.modal-menu-button')
  let addButton = null
  Array.from(modalMenuButtons).every(button => {
    let buttonFunction = button.getAttribute('data-function')
    let buttonTarget = button.getAttribute('data-target')
    if (buttonFunction == 'show' && buttonTarget == target) {
      addButton = button
      return false
    }
    return true
  })
  let fieldset = modal.querySelector('.' + target)
  let fieldsInFieldset = fieldset.querySelectorAll('input')
  if (fieldsInFieldset.length == 0) { fieldsInFieldset = fieldset.querySelectorAll('textarea') }
  fieldsInFieldset.forEach(field => {
    field.setAttribute('data-is-inactive', 'true')
  })
  fieldset.classList.add('is-hidden')
  button.classList.add('is-hidden')
  let field = fieldset.querySelector('input')
  if(!field) field = fieldset.querySelector('textarea')
  field.value = ''
  let fieldContextContainer = field.parentNode.querySelector('.field-response-container')
  if (fieldContextContainer && fieldContextContainer.getAttribute('data-target-name') == 'oxg-field-deadline') {
    oxgRemoveUfsFromContainer(fieldContextContainer)
  }
  addButton.classList.remove('is-hidden')
}

/*
  #SECTION Sidebar
*/ 

/*
  #ANCHOR Add to Briefing Sidebar
*/

window.oxgCheckModalForm = (button) => {
  let modalId = button.getAttribute('data-modal-id')
  let modal = getModalFromId(modalId)
  checkModalThenAdd(modal)
}

const checkModalThenAdd = (modal) => {
  if(!modal) return
  if (oxgRequiredFieldsAreOkay(modal)) { 
    let fieldValues = oxgGetFieldValuesFromModal(modal)
    let additionalInfos = oxgGetAdditionalInfosFromModal(modal)
    if (!fieldValues) { fieldValues = false }
    if (!additionalInfos ) { additionalInfos = false }
    let responseContainer = modal.querySelector('.modal-response-container')
    oxgRemoveUfsFromContainer(responseContainer)
    oxgAddAssetToSidebar(modal, fieldValues, additionalInfos)
  } else {
    let modalBody = modal.querySelector('.body')
    let responseContainer = modal.querySelector('.modal-response-container')
    oxgScrollToChild(modalBody, responseContainer, -200, function() {
      oxgRemoveUfsFromContainer(responseContainer)
      let uf = oxgCreateUf({
        format: 'box',
        icon: 'exclamation-mark--circled',
        style: 'danger',
        message: 'Please fill out all fields marked with an asterix (*)',
        messageDe: 'Bitte fülle alle Pflichtfelder (*) aus',
        container: responseContainer,
        classes: ['m-xs-top'],
        return: true,
      })
    })
    //scrollToTop(modalBody, 0, 'instant')
    //modalUserFeedbackBox.classList.remove('is-hidden')
  }
}

const oxgAddAssetToSidebar = (modalElement, fieldValues, additionalInfos) => {
  if(!oxgAssetBriefingItems) { console.error('oxgAssetBriefingItems variable not found'); return }

  // Get elements
  let modalId = modalElement.getAttribute('data-modal-id')
  let sidebar = document.getElementById('oxg-sidebar')
  let sidebarMain = sidebar.querySelector('.main')
  let modalPrototype = getModalPrototypeFromModalId(modalId)
  let cartItemId = oxgGenerateUniqueId()

  //true name 
  let assetTrueName = modalElement.querySelector('h3.asset-true-name').innerText

  //display name
  let nameField = modalElement.querySelector('.field-name')
  console.log("modalPrototype['data']", modalPrototype['data'])
  let displayName = modalPrototype['data']['asset_versions']['info']['display_name']
  let name = displayName ? displayName : modalPrototype['data']['name']
  if(nameField && nameField.value) { 
    let regex = /\S/;
    if (regex.test(nameField.value)) {
      //if returns false, if only spaces in text field
      name = nameField.value.trim()
    }
  }
  let incrementedName = oxgIncrementNameMaybe(modalElement, name, true)
  if(incrementedName) {
    nameField.value = incrementedName
    name = incrementedName
  }

  //asset-id
  let assetPostId = modalElement.querySelector('.asset-version').getAttribute('data-asset-id')

  //deadline
  let deadlineField = modalElement.querySelector('.field-deadline')
  let hasDeadline = false
  let deadline = null
  if(deadlineField) { if (deadlineField.value) { 
    hasDeadline = true 
    deadline = deadlineField.value
  }}

  //file
  let file = modalElement.querySelector('.field-file')
  let hasFile = false
  let fileDsiplayName = null
  let shortenedFileDisplayName = null
  if(file) { 
    if (file.files && file.files[0]) { 
      hasFile = true
      fileDsiplayName = file.files[0]['name'] 
      if (fileDsiplayName && typeof(fileDsiplayName) == 'string' && fileDsiplayName.length > 17) {
        shortenedFileDisplayName = fileDsiplayName.slice(0,17) + '...'
      }
    } 
  }

  //description
  let descriptionField = modalElement.querySelector('.field-description')
  let hasDescription = false
  let description = null
  if(descriptionField) { if (descriptionField.value) { 
    hasDescription = true 
    description = descriptionField.value
  }}

  //format missing?
  let formatOverride = modalElement.querySelector('.field-formats-override')
  let missingFormat = false
  if (formatOverride && formatOverride.checked) { missingFormat = true }

  //price
  let price = modalElement.querySelector('.estimated-price')
  let priceText = price.innerText
  if (price.innerText.includes('missing data')) {priceText = 'Price tbd.'}

  //create sidebar item
  let sidebarItemData = {
    modalId: modalId,
    cartItemId: cartItemId,
    displayName: name,
    hasDeadline: hasDeadline,
    hasDescription: hasDescription,
    hasFile: hasFile,
    missingFormat: missingFormat,
    priceText: priceText,
    shortenedFileDisplayName: shortenedFileDisplayName,
    deadline: deadline
  }
  let child = createNewSidebarItem(sidebarItemData)
  sidebarMain.appendChild(child)

  // Flag that unsaved changes exist
  oxgAssetBriefingCurrentSave.unsavedChanges = true;
  writeOxgAssetBriefingCurrentSaveToSession()
  if (oxgAssetBriefingCurrentSave.isActive) {
    //updateSaveInterface({showSaveDraftAsBtn: false, showSaveDraftBtn: true, showNewBriefingBtn: true, showUnsavedChangesInfo: true, showSavedInfoline: false})
  } else {
    //updateSaveInterface({showSaveDraftAsBtn: true, showSaveDraftBtn: false, showNewBriefingBtn: true, showUnsavedChangesInfo: true, showSavedInfoline: false})
  }

  let assetBriefingFeedEmpty = document.getElementById('briefing-feed-empty-container')
  let sidebarFeedResponseContainer = assetBriefingFeedEmpty.querySelector('.sidebar-feed-response')
  oxgRemoveUfsFromContainer(sidebarFeedResponseContainer)

  //cloning
  let modalClone = modalElement.cloneNode(true)
  modalClone.setAttribute('data-cart-item-id', cartItemId)
  let sidebarItemClone = child.cloneNode(true)

  //global variable update
  oxgAssetBriefingItems.push({
    'assetPostId': assetPostId,
    'assetName': assetTrueName,
    'type': 'asset',
    'cartItemId': cartItemId,
    'modalId': modalId,
    'modal': modalClone,
    'sidebarItem': sidebarItemClone,
    'hasDeadline': hasDeadline,
    'hasFile': hasFile,
    'fileDisplayName': fileDsiplayName,
    'shortenedFileDisplayName': shortenedFileDisplayName,
    'hasDescription': hasDescription,
    'price': priceText,
    'specs' : fieldValues,
    'additionalInfos': additionalInfos,
  })

  //Update Session Storage
  sessionStorage.setItem(cartItemId + '-sidebar-item', sidebarItemClone.outerHTML)
  sessionStorage.setItem(cartItemId + '-modal', modalClone.outerHTML)

  //clean up modals container
  let modal = document.getElementById('oxg-modal-' + modalId)
  let modalsContainer = document.getElementById('oxg-modals-container')
  if(!modal) return
  modal.remove()
  let modals = modalsContainer.querySelectorAll('oxg-modals')
  if (modals.length == 0) {
      modalsContainer.classList.remove('is-active')
  }

  //add data to hidden form
  syncBriefingForm()

  //dispatch event
  let oxgAssetAddedToSidebar = new Event('oxgAssetAddedToSidebar')
  document.dispatchEvent(oxgAssetAddedToSidebar)

  //update session
  sessionStorage.setItem('oxgAssetBriefingItems', JSON.stringify(oxgAssetBriefingItems))
}

const createSidebarItemDataFromStorage = (storedObject) => {
  if (storedObject.type != 'asset') return
  let specs = storedObject.specs
  let displayName, missingFormat, deadline, fileName
  specs.forEach((object, index) => {
    if ('optionName' in object && object.optionName == 'display_name') {
      displayName = object.value
    }
    if ('optionName' in object && object.optionName == 'format_override') {
      missingFormat = object.value == 'on' ? true : false
    }
    if ('optionName' in object && object.optionName == 'deadline') {
      deadline = object.value
    }
    if ('optionName' in object && object.optionName == 'file_name') {
      fileName = object.value
    }
  })
  let data = {
    modalId: storedObject.modalId,
    cartItemId: storedObject.cartItemId,
    displayName: displayName,
    hasDeadline: storedObject.hasDeadline,
    hasDescription: storedObject.hasDescription,
    hasFile: storedObject.hasFile,
    missingFormat: missingFormat,
    priceText: storedObject.price,
    shortenedFileDisplayName: storedObject.shortenedFileDisplayName,
    deadline: deadline
  }
  console.log('createSidebarItemDataFromStorage data', data)
  return data
}

const createNewSidebarItem = (data) => {
  console.log('createNewSidebarItem data', data)
  let sidebarItem = document.createElement('div')
  sidebarItem.setAttribute('id', 'cart-item-' + data.cartItemId)
  sidebarItem.setAttribute('aria-label', 'Sidebar item')
  let markup = '<div aria-label="Cart Item" class="card b-left cart-item bg2-i tc-medium m-xxs-bottom br-s hover-menu-parent" tabindex="99999" data-cart-item-id="' + data.cartItemId + '" style="border-width: 2px;">'
    + '<div class="body">'
      + '<div role="presentation" class="flex justify-spaced align-center">'
        + '<div role="presentation" class="text fs2 lh-compact">'
          + '<span class="tc-primary"><strong>' + data.displayName + '</strong></span><br>';
          if (data.hasDeadline) { markup += '<span class="tc-medium fs2">' + data.deadline + '</span>'; }
          if (data.hasDeadline && (data.hasFile || !data.hasDescription)) { markup += ', '; }
          if (data.hasFile) { markup += '<span class="tc-medium fs2">' + data.shortenedFileDisplayName + '</span>'; }
          if (data.hasFile && !data.hasDescription) { markup += ', '; }
          if (!data.hasDescription) { markup += '<span class="tc-medium fs2">No Description</span>'; }
          if ((!data.hasDescription || data.hasFile) && data.missingFormat) { markup += ', '; }
          if (data.missingFormat) { markup += '<span class="tc-medium fs2">Missing Format</span>'; }
          if (data.hasDeadline || data.hasFile || !data.hasDescription || data.missingFormat) { markup += '<br>' }
          markup += '<span class="tc-info fs2">' + data.priceText + '</span>'
        + '</div>'
      + '</div>'
    + '</div>'
    + '<div role="presentation" class="hover-overlay"></div>'
    + '<div class="signal" role="presentation"></div>'
    + '<div role="presentation" class="hover-menu p-xs">'
      + '<a tabindex="99999" href onclick="event.preventDefault(); oxgEditAssetFromBriefingSidebar(this)" class="icon-button hover-menu-edit-btn padded style-primary size-s" data-modal-id="' + data.modalId + '" role="button" data-cart-item-id="' + data.cartItemId + '"><span class="icon-pen"></span<></a>'
      + '<a tabindex="99999" href onclick="event.preventDefault(); oxgDeleteAssetFromBriefingSidebar(this)" class="icon-button hover-menu-delete-btn padded style-primary size-s" data-modal-id="' + data.modalId + '" data-cart-item-id="' + data.cartItemId + '" role="button"><span class="icon-trash-can"></span<></a>'
    + '</div>'
  + '</div>';
  sidebarItem.innerHTML = markup
  return sidebarItem
}

/*
  #ANCHOR Delete Item from Briefing Sidebar
*/ 

window.oxgDeleteAssetFromBriefingSidebar = (elem) => {
  let id = elem.getAttribute('data-modal-id')
  let cartItemId = elem.getAttribute('data-cart-item-id')
  oxgRemoveItemFromBriefingForm(cartItemId)
  removeItemFromSessionStorage(cartItemId)
  oxgAssetBriefingItems = removeModalFromArray(cartItemId, oxgAssetBriefingItems)
  removeItemFromCart(cartItemId)
  if(oxgAssetBriefingCurrentSave) {
    oxgAssetBriefingCurrentSave.unsavedChanges = true;
    writeOxgAssetBriefingCurrentSaveToSession()
  }
  //updateSaveInterface({showSaveDraftAsBtn: false, showSaveDraftBtn: true, showNewBriefingBtn: true, showUnsavedChangesInfo: true, showSavedInfoline: false})
  let assetDeletedFromSidebar = new Event('assetDeletedFromSidebar');
  document.dispatchEvent(assetDeletedFromSidebar);
}

/*
  #ANCHOR Update Item in Briefing Sidebar
*/

window.oxgCheckModalFormUpdate = (button) => {
  // Get items
  let modalId = button.getAttribute('data-modal-id')
  console.log('removing item of modal id "' + modalId + '" from sidebar, briefing form and oxgAssetBriefingItems')
  let modal = getModalFromId(modalId)
  let cartItemId = modal.getAttribute('data-cart-item-id')

  // Test
  console.log('removing item of cart item id "' + cartItemId + '" from sidebar, briefing form and oxgAssetBriefingItems')

  // Remove from Local Var
  oxgAssetBriefingItems = removeModalFromArray(cartItemId, oxgAssetBriefingItems)
  removeItemFromCart(cartItemId)
  oxgRemoveItemFromBriefingForm(cartItemId)
  checkModalThenAdd(modal)
}

/*
  #ANCHOR Edit item in Briefing Sidebar
*/ 

window.oxgEditAssetFromBriefingSidebar = (elem) => {
  if(!oxgAssetBriefingItems) { console.error('oxgAssetBriefingItems variable not found'); return }
  let cartItemId = elem.getAttribute('data-cart-item-id')
  oxgAssetBriefingItems.forEach(modalObject => {
    if(modalObject['cartItemId'] == cartItemId) {
      oxgEditCartItemModal(modalObject)
    }
  })
}

const oxgEditCartItemModal = (modalObject)=> {
  
  // Get Objects & ID
  let modal = modalObject['modal']
  let modalId = modalObject['modalId']
  let modalsContainer = document.getElementById('oxg-modals-container')
  
  // Sync Data
  syncModalWithSpecs(modalObject)

  // Append Modal
  modalsContainer.classList.add('is-active')
  modalsContainer.appendChild(modal)

  showHideModalAdditionalBlocks(modalObject)

  // Update Deadline User Message
  updateDeadlineUserMessage(modal)

  // Reset Error Message
  let errorMessage = document.getElementById('oxg-modal-error-message-' + modalId)
  errorMessage.classList.add('is-hidden')

  // Update Primary Button
  let primaryButton = document.getElementById('oxg-modal-primary-action-button-' + modalId)
  let buttonText = primaryButton.getAttribute('data-update-text')
  let buttonIcon = primaryButton.getAttribute('data-update-icon')
  primaryButton.innerHTML = buttonText + '<span class="p-xs-left ' + buttonIcon + '"></span>'
  primaryButton.setAttribute('onclick', 'event.preventDefault(); oxgCheckModalFormUpdate(this)')
  
  // Close Buttons
  let closeButton = document.getElementById('oxg-close-modal-button-' + modalId)
  let modalBg = document.getElementById('oxg-modal-bg-' + modalId)
  closeButton.addEventListener('click', (e)=> {
      e.preventDefault()
      oxgCloseModalAnimated(modalId)
  })
  modalBg.addEventListener('click', (e)=> {
      e.preventDefault()
      oxgCloseModalAnimated(modalId)
  }) 

  // Event dispatch
  let event = new Event('oxgModalsContainerOpen')
  document.dispatchEvent(event)
  event = new Event('oxgModalOpen')
  document.dispatchEvent(event)
}

//#!SECTION

/*
  #SECTION NEW Event Listeners
*/ 

/*
  #ANCHOR Modal Event Listeners 2
*/ 

const oxgAddModalFieldEventListeners2 = (modal)=> {
  let fields = modal.querySelectorAll('input[data-option-name="complexity"], input[data-option-name="pages"], input[data-option-name="pages_user_input"], input[data-option-name="pages_override"], input[data-option-name="format"], input[data-option-name="format_override"] input[data-option-name="media_type"], input[data-option-name="device_type"], input[data-option-name="social_media_post_type"]')
  let modalId = modal.getAttribute('data-modal-id')
  let modalData = oxgModalsData[modalId]['data']['asset_versions']['versions']
  if (!fields) return
  fields = Array.from(fields)
  fields.forEach(field => {
    field.addEventListener('change', ()=> {
      oxgUpdatePossibleModalOptions(fields, modal, modalData, modalId)
    })
  })
}

/*
  #ANCHOR Get Possible Asset Versions
*/ 

const oxgUpdatePossibleModalOptions = (fields, modal, modalData, modalId)=> {
  let possibleVersions = []
  let config = {}
  fields.forEach(field => {
    let optionName = field.getAttribute('data-option-name')
    let type = field.getAttribute('type')
    if(type == 'radio' || type == 'checkbox') {
      if (field.checked == true) {
        config[optionName] = field.value
      }
    } else if (type == 'hidden') {
      if(field.value) {
        config[optionName] = field.value
      }
    }
  })
  modalData.forEach(version => {
    let isPossible = true;
    if (version.complexity && config.complexity && config.complexity != version.complexity ) {
      isPossible = false;
    }
    if (version.pages && config.pages && !config.pages_override && config.pages != version.pages ) {
      isPossible = false;
    }
    if (version.format && config.format && !config.format_override && config.format != version.format ) {
      isPossible = false;
    }
    if (version.social_media_post_type && config.social_media_post_type && config.social_media_post_type != version.social_media_post_type ) {
      isPossible = false;
    }
    if (version.media_type && config.media_type && config.media_type != version.media_type ) {
      isPossible = false;
    }
    if (version.device_type && config.device_type && config.device_type != version.device_type ) {
      isPossible = false;
    }
    if(isPossible) {
      possibleVersions.push(version.id)
    }
  })
  let modalBody = modal.querySelector('#modal-body-' + modalId)
  modalBody.setAttribute('data-versions', JSON.stringify(possibleVersions))
}

//#!SECTION

/*
  #SECTION Helpers
*/ 

window.oxgAssetBriefingPrev = (page)=> {
  console.log(page)
  if(page == 1) {
    page = ''
  }
  window.open(window.location.origin + '/asset-briefing-' + page, '_self')
}

const updateSaveInterface = (options = {
  showSaveDraftBtn: 'as-is',
  showSaveDraftAsBtn: 'as-is',
  showNewBriefingBtn: 'as-is',
  showSavedInfoline: 'as-is',
  showUnsavedChangesInfo: 'as-is',
})=> {

  // Get Elements
  let unsavedChangesInfo = document.getElementById('unsaved-changes-infoline')
  let saveDraftAsBtn = document.getElementById('save-draft-as-btn')
  let saveDraftBtn = document.getElementById('save-draft-btn')
  let newBriefingBtn = document.getElementById('new-briefing-btn')
  let savedInfoline = document.getElementById('saved-infoline')
  
  // Unsaved Changes Info
  if ( !options.showUnsavedChangesInfo ) {
    unsavedChangesInfo.classList.add('is-hidden')
    unsavedChangesInfo.setAttribute('aria-hidden', 'true')
  } else if ( options.showUnsavedChangesInfo != 'as-is' ) {
    unsavedChangesInfo.classList.remove('is-hidden')
    unsavedChangesInfo.removeAttribute('aria-hidden')
  }
  
  // Save Draft Button
  if ( !options.showSaveDraftBtn ) {
    saveDraftBtn.classList.add('is-hidden')
    saveDraftBtn.setAttribute('aria-hidden', 'true')
  } else if ( options.showSaveDraftBtn != 'as-is' ) {
    saveDraftBtn.classList.remove('is-hidden')
    saveDraftBtn.removeAttribute('aria-hidden')
  }

  // Save Draft As Button
  if ( !options.showSaveDraftAsBtn ) {
    saveDraftAsBtn.classList.add('is-hidden')
    saveDraftAsBtn.setAttribute('aria-hidden', 'true')
  } else if ( options.showSaveDraftAsBtn != 'as-is' ) {
    saveDraftAsBtn.classList.remove('is-hidden')
    saveDraftAsBtn.removeAttribute('aria-hidden')
  }

  // Save Draft As Button
  if ( !options.showNewBriefingBtn ) {
    newBriefingBtn.classList.add('is-hidden')
    newBriefingBtn.setAttribute('aria-hidden', 'true')
  } else if ( options.showNewBriefingBtn != 'as-is' ) {
    newBriefingBtn.classList.remove('is-hidden')
    newBriefingBtn.removeAttribute('aria-hidden')
  }

  // Saved Infoline
  if ( !options.showSavedInfoline ) {
    savedInfoline.classList.add('is-hidden')
    savedInfoline.setAttribute('aria-hidden', 'true')
  } else if ( options.showSavedInfoline != 'as-is' ) {
    savedInfoline.classList.remove('is-hidden')
    savedInfoline.removeAttribute('aria-hidden')
  }
}

/*
  #ANCHOR Get Subline & Infoline
*/

const getPageSubline = ()=> {
  let subline = document.getElementById('asset-briefing-subline')
  return subline
}

const getPageInfoline = ()=> {
  let subline = document.getElementById('asset-briefing-infoline')
  return subline
}

/*
  #ANCHOR Get DE / EN
*/

const getDeEn = ()=> {
  let lang = oxgGetLang()
  if(!lang) return
  let deEn = oxgLangDeOrEn(lang)
  return deEn
}

/*
  #ANCHOR Sync Modal With Specs
*/ 

/**
 * This is how an asset modals markup is restored to the exact configuration, after a briefing has been loaded from the database.
 * Context: When an asset is added to the sidebar, the modals exact markup is saved in a local variable. When the user wants to edit asset in question, the modal is restored from that variable. 
 * Meaning all checked radio buttons etc. will be as the user left them. But when an asset briefing has just been loaded from the database, the local variable and sesion storage only contain the
 * base markup of the modal, not the specific configuration of the user. So the below function goes through the asset specs (which have been loaded from the database) and restores the exact
 * markup of the modal 
 */

const syncModalWithSpecs = (modalObject)=> {
  let modal = modalObject.modal
  let specs = modalObject.specs
  let inputFields = modal.querySelectorAll('input')
  let textareas = modal.querySelectorAll('textarea')
  inputFields.forEach(field => {
    let dataOptionName = field.getAttribute('data-option-name')
    if (dataOptionName) {
      let spec = specs.find(obj => obj.optionName === dataOptionName)
      if( spec ) {
        let specValue = spec.value
        if (field.type != 'radio' && field.type != 'checkbox' ) {
          field.value = specValue
        } else if (field.value == specValue ) {
          field.checked = true
        }
      } 
    }
  })
  textareas.forEach(textarea => {
    let dataOptionName = textarea.getAttribute('data-option-name')
    if (dataOptionName) {
      let spec = specs.find(obj => obj.optionName === dataOptionName)
      if( spec ) {
        textarea.value = spec.value
      } 
    }
  })
}

const showHideModalAdditionalBlocks = (modalObject)=> {
  let modal = modalObject.modal
  let specs = modalObject.specs
  let showLanguagesField = false
  let showOpenDataFeeInfo = false
  let showReferenceProjectField = false
  let translationOption = specs.find(obj => obj.optionName === 'translation')
  if(translationOption && translationOption.value == 'on') {
    showLanguagesField = true
  }
  let openDataRequiredOption = specs.find(obj => obj.optionName === 'open_data_required')
  if(openDataRequiredOption && openDataRequiredOption.value == 'on') {
    showOpenDataFeeInfo = true
  }
  let complexityOption = specs.find(obj => obj.optionName === 'complexity')
  if(complexityOption) {
    if (complexityOption.value == 'Hybrid' || complexityOption.value == 'Adaptation') {
      showReferenceProjectField = true
    }
  }
  
  if(showLanguagesField) {
    let additionalBlock = modal.querySelector('div[data-additional-block-name=translation-languages]')
    additionalBlock.classList.remove('is-hidden')
    additionalBlock.setAttribute('is-inactive', 'false')
  }
  if(showOpenDataFeeInfo) {
    let additionalBlock = modal.querySelector('div[data-additional-block-name=open-data-fee-info]')
    additionalBlock.classList.remove('is-hidden')
    additionalBlock.setAttribute('is-inactive', 'false')
  }
  if(showReferenceProjectField) {
    let additionalBlock = modal.querySelector('div[data-additional-block-name=project-reference]')
    additionalBlock.classList.remove('is-hidden')
    additionalBlock.setAttribute('is-inactive', 'false')
  }
}

/*
  #ANCHOR Add Event Listeners
*/ 

const oxgGetRangeForPage = (pageTextInputField) => {
  let pageNumber = pageTextInputField.value
  let rangesAttribute = pageTextInputField.getAttribute('data-page-ranges');
  const ranges = JSON.parse(rangesAttribute.replace(/'/g, '"')); // Replace single quotes to make it a valid JSON string
    for (let range of ranges) {
        if (range.includes('-')) {
            // Handle ranges like '2-6'
            let [min, max] = range.split('-').map(Number);
            if (pageNumber >= min && pageNumber <= max) {
                return range;
            }
        } else if (range.startsWith('>')) {
            // Handle ranges like '>16'
            let min = Number(range.slice(1));
            if (pageNumber > min) {
                return range;
            }
        } else if (range.startsWith('<')) {
            // Handle ranges like '<10' if needed
            let max = Number(range.slice(1));
            if (pageNumber < max) {
                return range;
            }
        }
    }
    return false
}

const oxgAddModalFieldEventListeners = (modal)=> {
  let radioButtons = modal.querySelectorAll('input[type="radio"]')
  let multipliers = modal.querySelectorAll('input[data-is-price-multiplier]')
  
  //check for input field with syntax restriction
  let syntaxRestrictedFields = modal.querySelectorAll('input[data-restrict-syntax]')
  if(syntaxRestrictedFields.length > 0) {
    Array.from(syntaxRestrictedFields).forEach(field => {
      let fieldClone = field.cloneNode(true)
      fieldClone.classList.add('is-clone')
      let fieldParent = field.parentNode
      field.remove()
      fieldParent.appendChild(fieldClone)
      let syntax = fieldClone.getAttribute('data-restrict-syntax')
      let responseContainer = document.getElementById('frc-' + fieldClone.getAttribute('id'))
      let errorMessage = fieldClone.getAttribute('data-syntax-error-message')
      let minNumber = fieldClone.getAttribute('data-min-number')
      let maxNumber = fieldClone.getAttribute('data-max-number')
      fieldClone.addEventListener('change', ()=> {
        if (syntax == 'printable-page-numbers') {
          if (fieldClone.value) {
            let syntaxOkay = oxgIsStringPageAmountPrintable(fieldClone.value)
            if(!syntaxOkay) {
              fieldClone.value = null;
              let hiddenFieldId = fieldClone.getAttribute('data-hidden-field')
              let hiddenField = modal.querySelector('#' + hiddenFieldId)
              console.log('updating hidden pages field')
              hiddenField.value = null
              oxgRemoveUfsFromContainer(responseContainer)
              oxgCreateUf({
                format: 'text',
                icon: 'exclamation-mark--circled',
                style: 'danger',
                message: errorMessage,
                messageDe: errorMessage,
                container: responseContainer,
                classes: ['m-xs-v'],
                return: true,
              })
            } else {
              let number = parseInt(fieldClone.value)
              if(number >= minNumber && number <= maxNumber ) {
                let previousMessage = responseContainer.querySelector('.uf-element') 
                if (previousMessage) {
                  oxgRemoveUfsFromContainer(responseContainer)
                  let uf = oxgCreateUf({
                    format: 'text',
                    icon: 'check-mark',
                    style: 'success',
                    message: 'Number of pages is printable',
                    messageDe: 'Seitenzahl ist druckbar',
                    container: responseContainer,
                    classes: ['m-xs-v'],
                    signal: 'false',
                    return: true,
                  })
                  setTimeout(function() {
                    uf.remove()
                  }, 1000)
                }
              } else {
                let errorMessage = { 
                  en: 'Amount of pages must be at least ' + minNumber + ' and a maximum of ' + maxNumber,
                  de: 'Seitenzahl muss mindestens ' + minNumber + ' und darf maximal ' + maxNumber + ' sein'
                }
                if (maxNumber == 9999) {
                  errorMessage = { 
                    en: 'Amount of pages must be at least ' + minNumber,
                    de: 'Seitenzahl muss mindestens ' + minNumber + ' sein'
                  }
                }
                oxgRemoveUfsFromContainer(responseContainer)
                oxgCreateUf({
                  format: 'text',
                  icon: 'exclamation-mark--circled',
                  style: 'danger',
                  message: errorMessage.en,
                  messageDe: errorMessage.de,
                  container: responseContainer,
                  classes: ['m-xs-v'],
                  return: true,
                })
              }
            }
          }
        } else if (syntax == 'number') {

        }
      })
    })
  }

  // Radio Buttons
  Array.from(radioButtons).forEach(radioButton => {
    radioButton.addEventListener('change', ()=> {
      oxgUpdateModalAssetPrice(modal)
    })
  })

  // Multipliers
  Array.from(multipliers).forEach(multiplier => {
    if(multiplier.getAttribute('type') != 'radio') {
      multiplier.addEventListener('change', ()=> {
        oxgUpdateModalAssetPrice(modal)
      })
    }
  })

  // Pages Text Field
  let userInputFieldsPages = modal.querySelectorAll('input[data-pages-are-ranges]')
  Array.from(userInputFieldsPages).forEach(pageTextInputField => {
    console.log('pageTextInputField', pageTextInputField)
    let responseContainerId = 'frc-' + pageTextInputField.getAttribute('id')
    responseContainerId = responseContainerId.endsWith('-user-input') ? responseContainerId.slice(0, -'-user-input'.length) : responseContainerId
    let responseContainer = document.getElementById(responseContainerId)
    console.log(responseContainer)
    pageTextInputField.addEventListener('change', ()=> {
      console.log('Pages Text Input Change')
      if(pageTextInputField.value) {
        let range = oxgGetRangeForPage(pageTextInputField)
        if(!range) {
          let hiddenFieldId = pageTextInputField.getAttribute('data-hidden-field')
          let hiddenField = modal.querySelector('#' + hiddenFieldId)
          hiddenField.value = null

          oxgRemoveUfsFromContainer(responseContainer)
          let uf = oxgCreateUf({
            format: 'text',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'Sorry, but your chosen page number is not available for this asset',
            messageDe: 'Deine gewählte Seitenzahl wird für dieses Asset leider nicht angeboten',
            container: responseContainer,
            classes: ['m-xs-top', 'm-xs-bottom'],
            return: true,
          })
          pageTextInputField.value = null
        } else {
          let hiddenFieldId = pageTextInputField.getAttribute('data-hidden-field')
          let hiddenField = modal.querySelector('#' + hiddenFieldId)
          hiddenField.value = range
          let previousMessage = responseContainer.querySelector('.uf-element') 
          if (previousMessage) {
            oxgRemoveUfsFromContainer(responseContainer)
            let uf = oxgCreateUf({
              format: 'text',
              icon: 'check-mark',
              style: 'success',
              message: 'Page number is available',
              messageDe: 'Seitenzahl ist verfügbar',
              container: responseContainer,
              classes: ['m-xs-top', 'm-xs-bottom'],
              return: true,
              signal: 'false',
            })
            setTimeout(function() {
              uf.remove()
            }, 1000)
          }
        }
      } else {
        let hiddenFieldId = pageTextInputField.getAttribute('data-hidden-field')
        let hiddenField = modal.querySelector('#' + hiddenFieldId)
        hiddenField.value = null
      }
      console.log('updating hidden field 2')
      oxgUpdateModalAssetPrice(modal)
    })
  })

  let addFilesButton = modal.querySelector('.modal-add-files-button')
  let removeFilesButton = modal.querySelector('.modal-remove-files-button')
  let filesContainer = modal.querySelector('.files-container')

  if (!filesContainer.classList.contains('is-hidden')) {
    oxgListenForFileSelection(modal)
  } else {
    addFilesButton.addEventListener('click', (e)=> {
      oxgListenForFileSelection(modal)
    })
  }

  // Remove Files button
  removeFilesButton.addEventListener('click', (e)=> {
    oxgRemoveAnySelectedFiles(modal)
  })
}

/*
  #ANCHOR Listen Date Change
*/ 

const oxgListenForDateChange = (modal)=> {
  let element = modal.querySelector('.oxg-datepicker-async')
  console.log(element)
  oxgDatepickers = datepicker(element, {
    minDate: new Date(),
    startDay: 1,
    noWeekends: true,
    formatter: (input, date, instance) => {
      const value = date.toLocaleDateString()
      input.value = value // => '1/1/2099'
    },
    customDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    customMonths: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    customOverlayMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    overlayPlaceholder: '4-stellige Jahreszahl',
    showAllDates: true,
    overlayButton: "Okay",
    startDate: oxgGetTodayPlusDays(14),
    onSelect: (instance, date) => {
      let field = instance.el
      let fieldResponseContainer = field.parentNode.querySelector('.field-response-container')
      checkDeadlineField(field, fieldResponseContainer, {date: date, context: 'js-datepicker'})
    },
  })
  oxgDatepickers.calendarContainer.style.setProperty('font-size', '1.875rem')
  oxgDatepickers.toggleOverlay()
  console.log('oxgDatepickers', oxgDatepickers)
}

const updateDeadlineUserMessage = (modal) => {
  //input field
  let fieldContainer = modal.querySelector('.deadline-container')
  let field = fieldContainer.querySelector('.field-deadline')
  let fieldResponseContainer = field.parentNode.querySelector('.field-response-container')
  checkDeadlineField(field, fieldResponseContainer, {clearPastDate: false})
}

/*
  #ANCHOR Remove Item to Briefing Form
*/ 

const oxgRemoveItemFromBriefingForm = (cartItemId)=> {
  let assetsField = document.getElementById('briefing-assets')
  let assetsFieldValue = []
  if (assetsField.value) {
    try {
      assetsFieldValue = JSON.parse(assetsField.value);
      if (!Array.isArray(assetsFieldValue)) {
        assetsFieldValue = [];
      }
    } catch (e) {
      console.error("Error parsing JSON:", e);
    }
  }
  if (assetsFieldValue) {
    assetsFieldValue = assetsFieldValue.filter((item) => item['cartItemId'] !== cartItemId)
    let updatedValue = JSON.stringify(assetsFieldValue)
    assetsField.value = updatedValue
  }
}

/*
  #ANCHOR Get Fields from Cart Item ID
*/

const oxgGetFieldsFromCartItem = (cartItemId)=> {
  if (!oxgAssetBriefingItems) return
  let asset = null
  oxgAssetBriefingItems.forEach(item => {
    if (item['cartItemId'] == cartItemId) {
      asset = item
    }
  })
  if(asset) {
    let assetVersion = asset['modal'].querySelector('.asset-version')
    let priceEstimated = asset['modal'].querySelector('.estimated-price')
    let additionalInfo = assetVersion.querySelector('.additional-info')
    let includedCorrections = assetVersion.querySelector('.included-corrections')
    let openDataDeliveryFee = assetVersion.querySelector('.open-data-fee')
    return {
      singles: {
        assetId: assetVersion.getAttribute('data-asset-id'),
        assetName: assetVersion.getAttribute('data-asset-type-name'),
        displayName: assetVersion.querySelector('.field-name').value ? assetVersion.querySelector('.field-name').value : null,
        deadline: assetVersion.querySelector('.field-deadline').value ? assetVersion.querySelector('.field-deadline').value : null,
        description: assetVersion.querySelector('.field-description').value ? assetVersion.querySelector('.field-description').value : null,
        fileName: assetVersion.querySelector('.field-file-name').value ? assetVersion.querySelector('.field-file-name').value : null,
      },
      multiples: {
        pageNumbers: assetVersion.querySelectorAll('.field-page-numbers') ? Array.from(assetVersion.querySelectorAll('.field-page-numbers')) : [],
        formats: assetVersion.querySelectorAll('.field-formats') ? Array.from(assetVersion.querySelectorAll('.field-formats')) : [],
        mediaTypes: assetVersion.querySelectorAll('.field-media-types') ? Array.from(assetVersion.querySelectorAll('.field-media-types')) : [],
        deviceTypes: assetVersion.querySelectorAll('.field-device-types') ? Array.from(assetVersion.querySelectorAll('.field-device-types')) : [],
        socialMediaPostTypes: assetVersion.querySelectorAll('.field-social-media-post-types') ? Array.from(assetVersion.querySelectorAll('.field-social-media-post-types')) : [],
        complexities: assetVersion.querySelectorAll('.field-complexities') ? Array.from(assetVersion.querySelectorAll('.field-complexities')) : [],
      },
      other: {
        priceEstimated: priceEstimated ? priceEstimated.innerText : null,
        additionalInfo: additionalInfo ? additionalInfo.innerText : null,
        includedCorrections: includedCorrections ? includedCorrections.innerText : null,
        openDataDeliveryFee: openDataDeliveryFee ? openDataDeliveryFee.innerText : null,
      },
    }
  }
}

/*
  #ANCHOR Get Version Specs from Fields
*/

const oxgGetAssetVersionSpecsFromFields = (fields)=> {
  console.log('oxgGetAssetVersionSpecsFromFields fields: ', fields)
  let singles = fields['singles']
  let multiples = fields['multiples']
  let other = fields['other']
  let pages, deviceType, mediaType, format, complexity, socialMediaPostType;
  let options = [...multiples['pageNumbers'], ...multiples['formats'], ...multiples['mediaTypes'], ...multiples['deviceTypes'], ...multiples['socialMediaPostTypes'], ...multiples['complexities']]
   options.forEach(field => {
    if (field.checked) {
      if (field.getAttribute('data-option-name') == 'pages') { pages = field.value }
      else if (field.getAttribute('data-option-name') == 'device-type') { deviceType = field.value }
      else if (field.getAttribute('data-option-name') == 'media_type') { mediaType = field.value }
      else if (field.getAttribute('data-option-name') == 'format') { format = field.value }
      else if (field.getAttribute('data-option-name') == 'complexity') { complexity = field.value }
      else if (field.getAttribute('data-option-name') == 'social_media_post_type') { socialMediaPostType = field.value }
    }
  })
  return {
    assetId: singles['assetId'] ? singles['assetId'] : null,
    assetName: singles['assetName'] ? singles['assetName'] : null,
    displayName: singles['displayName'] ? singles['displayName'] : null,
    deadline: singles['deadline'] ? singles['deadline'] : null,
    description: singles['description'] ? singles['description'] : null,
    fileName: singles['fileName'] && singles['fileName'].length > 0 ? singles['fileName'] : null,
    pages: pages,
    deviceType: deviceType,
    mediaType: mediaType,
    format: format,
    complexity: complexity,
    socialMediaPostType: socialMediaPostType,
    priceEstimated: other['priceEstimated'] ? other['priceEstimated'] : null,
    additionalInfo: other['additionalInfo'] ? other['additionalInfo'] : null,
    includedCorrections: other['includedCorrections'] ? other['includedCorrections'] : null,
    openDataDeliveryFee: other['openDataDeliveryFee'] ? other['openDataDeliveryFee'] : null,
  }
}

/*
  #SECTION Prices
*/ 

/*
  #ANCHOR Price is Pricey
*/ 

const oxgStringIsPricey = (s)=> {
  if (/[a-zA-Z]/.test(s)) {
    return false
  }
   // Check if there are multiple decimal points or commas, or if both are present
   if ((s.split('.').length - 1) > 1 || (s.split(',').length - 1) > 1) {
    return false
  }
  // Check if both comma and decimal point are present
  if (s.includes('.') && s.includes(',')) {
      return false
  }
  // Check for invalid characters (anything that's not a digit, '.', or ',')
  if (/[^0-9.,]/.test(s)) {
      return false
  }
  return true
}

/*
  #ANCHOR Get Relevant Prices
*/ 

const oxgGetModalCurrentRelevantPrices = (modal)=> {
  let id = modal.getAttribute('data-modal-id')
  if(oxgModalsData) {

    // Get asset
    let assetVersions = oxgModalsData[id]?.['data']?.['asset_versions']?.['versions']
    if(!assetVersions) return
    
    // Get all prices for that asset
    let prices = []
    assetVersions.forEach(version => {
      let price = version['price']
      if(!prices.includes(price)) { prices.push(price) }
    })

    // Get all fieldsets in the asset modal
    let fieldsets = modal.querySelectorAll('fieldset')
    
    //create relevant values object
    let relevantValues = {
      page_numbers: [],
      device_types: [],
      social_media_post_types: [],
      media_types: [],
      formats: [],
      complexities: [],
    }

    // Get hidden pages field if there is one
    let hiddenPagesField = modal.querySelector('input[data-option-name="pages"][type="hidden"]')
    if( hiddenPagesField && hiddenPagesField.value ) {
      let isInactive = hiddenPagesField.getAttribute('data-is-inactive')
      if (isInactive != 'true') {
        relevantValues.page_numbers[0] = hiddenPagesField.value
      }
    } else if ( (hiddenPagesField && !hiddenPagesField.value) || (hiddenPagesField && hiddenPagesField.value == 'undefined') ) {
      let pagesOverride = modal.querySelector('input[data-option-name="pages_override"][type="checkbox"]');
      if (pagesOverride && pagesOverride.checked) {
        let lowestPossiblePages = oxgGetLowestPossiblePageNumberVersion(assetVersions)
        relevantValues.page_numbers[0] = lowestPossiblePages
      }
    }

    //loop through fieldsets in modal
    fieldsets.forEach(fieldset => {
      let optionName = fieldset.getAttribute('data-name')
      if(optionName) {

        // Get all radio buttons
        let radioButtons = fieldset.querySelectorAll('input[type="radio"]')
        
        //create vars for fieldsets
        let fieldsetFilledOut = false
        let fieldsetAllValues = []
        let fieldsetCheckedValues = []
        let fieldsetRelevantValues = null

        //save which radio buttons are selected & if a fieldset has no selected values in vars
        Array.from(radioButtons).forEach(radioButton => {
          fieldsetAllValues.push(radioButton.value)
          if ( radioButton.checked ) {
            fieldsetCheckedValues.push(radioButton.value)
            fieldsetFilledOut = true
          }
        })

        if(!fieldsetFilledOut) {
          //if none of the radio buttons in a fieldset is selected, then all possible prices for the radio buttons values are still possible (i.e. Animated, Static, Video)
          fieldsetRelevantValues = fieldsetAllValues
        } else {
          //if not, only the prices are relevant, where the asset versions align with the checked field value (i.e. Animated)
          fieldsetRelevantValues = fieldsetCheckedValues
        }

        //push relevant prices into relevant values object
        relevantValues[optionName].push(fieldsetRelevantValues)
      }
    })

    //console.log(relevantValues)
    let pageNumbers, deviceTypes, socialMediaPostTypes, mediaTypes, formats, complexities
    if (relevantValues.page_numbers[0] && relevantValues.page_numbers[0].length > 0) { pageNumbers = relevantValues.page_numbers[0] }
    if (relevantValues.device_types[0] && relevantValues.device_types[0].length > 0) { deviceTypes = relevantValues.device_types[0] }
    if (relevantValues.social_media_post_types[0] && relevantValues.social_media_post_types[0].length > 0) { socialMediaPostTypes = relevantValues.social_media_post_types[0] }
    if (relevantValues.media_types[0] && relevantValues.media_types[0].length > 0) { mediaTypes = relevantValues.media_types[0] }
    if (relevantValues.formats[0] && relevantValues.formats[0].length > 0) { formats = relevantValues.formats[0] }
    if (relevantValues.complexities[0] && relevantValues.complexities[0].length > 0) { complexities = relevantValues.complexities[0] }
    let relevantPrices = []

    assetVersions.forEach(version => {
      //console.log(version)
      let isRelevant = true
      if(version.pages && pageNumbers && !pageNumbers.includes(version.pages)) {
        isRelevant = false
      }
      if(version.device_type && deviceTypes && !deviceTypes.includes(version.device_type)) {
        isRelevant = false
      }
      if(version.social_media_post_type && socialMediaPostTypes && !socialMediaPostTypes.includes(version.social_media_post_type)) {
        isRelevant = false
      }
      if(version.media_type && mediaTypes && !mediaTypes.includes(version.media_type)) {
        isRelevant = false
      }
      if(version.format && formats && !formats.includes(version.format)) {
        isRelevant = false
      }
      if(version.complexity && complexities && !complexities.includes(version.complexity)) {
        isRelevant = false
      }
      if(isRelevant) {
        if(!relevantPrices.includes(version.price)) {
          relevantPrices.push(version.price)
        }
      }
    })
    return relevantPrices
  }
}

const oxgGetLowestPossiblePageNumberVersion = (assetVersions) => {
  let lowest = null;
  let lowestPages = null;
  assetVersions.forEach(version => {
    let pages = version.pages
    if(pages) {
      let pagesTrimmed = pages.trim()
      let pageNumber = null
      let rangePattern = /^\d+-\d+$/;
      let singleNumberPattern = /^\d+$/;
      if (rangePattern.test(pagesTrimmed)) {
        let [num1, num2] = pagesTrimmed.split('-').map(Number);
        pageNumber = Math.max(num1, num2);
      } else if (singleNumberPattern.test(pagesTrimmed)) {
        pageNumber = parseInt(pagesTrimmed) 
      }
      if (!lowest || lowest > pageNumber) {
        lowest = pageNumber
        lowestPages = pages
      }
    }
  })
  return lowestPages
}

/*
  #ANCHOR Update Prices
*/ 

const oxgUpdateModalAssetPrice = (modal) => {
  let prices = oxgGetModalCurrentRelevantPrices(modal)
  console.log('current relevant prices', prices)
  let modalId = modal.getAttribute('data-modal-id')
  let priceElement = document.getElementById('oxg-modal-price-' + modalId)
  if(!priceElement) return
  let multipliers = modal.querySelectorAll('input[data-is-price-multiplier]')
  let minimumMultiplier = 1;
  let priceText = priceElement.querySelector('.price')
  let priceTextPrefix = priceElement.querySelector('.prefix')
  let prefixInitialText = priceTextPrefix.innerText
  let allPricesArePricey = true
  let prefix, priceSuffix
  let multiplierSuffix = ''
  let highest = prices[0]
  let lowest = prices[0]
  prices.forEach(price => {
    let isPricey = oxgStringIsPricey(price)
    if(!isPricey) {
      allPricesArePricey = false
    }
    if (Number(price) > Number(highest)) {
      highest = price
    }
    if (Number(price) < Number(lowest)) {
      lowest = price
    }
  })

  let factors = []
  let factor = 1
  let multiplierItemNames = []
  let lowestPossibleFactor = null;
  multipliers = Array.from(multipliers)
  multipliers.forEach(multiplier => {
    let fieldType = multiplier.getAttribute('type')
    let multiplierItemName = multiplier.getAttribute('data-multiplier-item-name')
    let multiplierItemNamePlural = multiplier.getAttribute('data-multiplier-item-name-plural')
    let checkedRadioButton = fieldType == 'radio' && multiplier.checked ? true : false;
    let textNumberField = fieldType == 'number' || fieldType == 'text' ? true : false
    let fieldValue = multiplier.value
    if( checkedRadioButton || textNumberField ) {
      multiplierItemNames.push(multiplierItemName)
      if (textNumberField) {
        let min = multiplier.getAttribute('data-min-number')
        if(min) {
          lowestPossibleFactor = min
        }
      }
      if (fieldValue) {
        let factorObject = {
          factor: parseInt(fieldValue),
          itemName: multiplierItemName,
          itemNamePlural: multiplierItemNamePlural
        }
        factor = factor * parseInt(fieldValue)
        factors.push(factorObject)
      }
    }
  })
  console.log('factor', factor)
  console.log('lowest possible factor', lowestPossibleFactor)
  if(lowestPossibleFactor && factor < lowestPossibleFactor) {
    factor = lowestPossibleFactor
    console.log('updating factor', factor)
  }
  console.log('factor as string', factor.toString())

  multiplierItemNames.forEach(function callback(name, index) {
    let itemPrefix = oxgLangDeOrEn(oxgGetLang()) == 'de' ? 'für' : 'for'
    if(index == 0) {
      multiplierSuffix += ' (' + itemPrefix + ' '
    } else {
      multiplierSuffix += ', '
    }
    multiplierSuffix += factor.toString() + ' ' + name
    if(index == multiplierItemNames.length - 1) {
      multiplierSuffix += ')'
    }
  })
  console.log('multiplierSuffix', multiplierSuffix)
  priceSuffix = allPricesArePricey ? ' €' : ''
  prefix = allPricesArePricey ? prefixInitialText : ''
  priceTextPrefix.innerText = prefix

  if(highest == lowest && allPricesArePricey) {
      highest = factor ? parseFloat(highest) * factor : highest
      highest = parseFloat(highest).toFixed(2)
      if (lowestPossibleFactor && factor > lowestPossibleFactor) {
        multiplierSuffix = oxgGetPriceMultiplierSuffix(factors)
      }
      priceText.innerText = highest + priceSuffix + multiplierSuffix
  } else if (allPricesArePricey) {
      lowest = factor ? parseFloat(lowest) * factor : lowest
      lowest = parseFloat(lowest).toFixed(2)
      highest = factor ? parseFloat(highest) * factor : highest
      highest = parseFloat(highest).toFixed(2)
      if (lowestPossibleFactor && factor > lowestPossibleFactor) {
        multiplierSuffix = oxgGetPriceMultiplierSuffix(factors)
      }
      priceText.innerText = lowest + ' – ' + highest + priceSuffix + multiplierSuffix
  } else {
    priceText.innerText = 'Price tbd.'
  }
}

const oxgGetPriceMultiplierSuffix = (factors)=> {
  let itemPrefix = oxgLangDeOrEn(oxgGetLang()) == 'de' ? 'für' : 'for'
  let suffix = '';
  factors.forEach(function callback(factor, index) {
    let itemName = factor.itemNamePlural
    if (factor.factor == 1) {
      itemName = factor.itemName
    }
    suffix += index == 0 ? ' (' + itemPrefix + ' ' : ', '
    suffix += factor.factor + ' ' + itemName
    suffix += index == factors.length - 1 ? ')' : ''
  })
  return suffix
}

/*
  #!SECTION Prices
*/ 

/*
  #ANCHOR Get Modal Prototype
*/ 
const getModalPrototypeFromModalId = (modalId) => {
  return oxgModalsData[modalId]
}

/*
  #ANCHOR Get Modal From ID
*/ 
const getModalFromId = (modalId) => {
  let modal = document.getElementById('oxg-modal-' + modalId)
  if(modal) { return modal } else { return null }
}

/*
  #ANCHOR Remove Modal From array
*/ 

const removeModalFromArray = (cartItemId, array) => {
  if (array) {
    array = array.filter((item) => cartItemId !== item['cartItemId'])
    return array
  }
  return array
}

/*
  #ANCHOR Remove Item From Cart
*/ 

const removeItemFromCart = (cartItemId) => {
  let sidebarElem = document.getElementById('cart-item-' + cartItemId)
  if(sidebarElem) {
    sidebarElem.remove()
    return true
  } 
  return false
}

/*
  #ANCHOR Increment Name Maybe
*/ 

const oxgIncrementNameMaybe = (modal, name, returnName = false)=> {
  let inCart = modal.getAttribute('data-cart-item-id')
  if(inCart) return
  let nameField = modal.querySelector('.field-name')
  if(name) {
    let existingNames = new Array
    let maxLoops = 100
    let loop = 1
    oxgAssetBriefingItems.forEach(item => {
      existingNames.push(item['assetDisplayName'])
    })
    while (loop < maxLoops && existingNames.includes(name)) {
      loop++
      name = oxgIncrementNumberAtStringEnd(name)
    }
    nameField.value = name
    if(returnName) {
      return name
    }
  }
}

/*
  #ANCHOR Required Fields Are Okay
*/ 

const oxgRequiredFieldsAreOkay = (modal)=> {
  let fieldsArray = Array.from(modal.querySelectorAll('input, textarea'))

  let radioCheckboxButtons = []
  let radioCheckboxButtonNames = []
  let checkedRadioCheckboxButtonNames = []
  let requiredRadioCheckboxButtonArrays = []
  let requiredOtherFields = []
  let checkboxes = []
  let submitButtons = []
  let hiddenFields = []
  let otherFields = []

  Array.from(fieldsArray).forEach(field => {
    let type = field.getAttribute('type')
    if (type == 'radio' || type == 'checkbox') {
      radioCheckboxButtons.push(field)
    } else if ( type == 'checkbox' ) {
      checkboxes.push(field)
    } else if ( type == 'hidden' ) {
      hiddenFields.push(field)
    } else if ( type == 'submit' ) {
      submitButtons.push(field)
    } else {
      otherFields.push(field)
    }
  })

  radioCheckboxButtons.forEach(button => {
    let name = button.getAttribute('name')
    console.log('radio/checkbox name', name)
    let isOverride = button.getAttribute('data-override') == 'true' ? true : false
    console.log(name + ' is override', isOverride)
    if (!radioCheckboxButtonNames.includes(name) && !isOverride) {
      radioCheckboxButtonNames.push(name)
      console.log('pushing radio/checkbox name', name)
    }
  })

  radioCheckboxButtons.forEach(button => {
    let name = button.getAttribute('name')
    let checked = button.checked
    let isOverride = button.getAttribute('data-override') == 'true' ? true : false
    if (checked && !isOverride) {
      checkedRadioCheckboxButtonNames.push(name)
    }
  })

  otherFields.forEach(field => {
    let name = field.getAttribute('name')
    if (field.required == true && field.value == '') {
      requiredOtherFields.push(name)
    }
  })

  radioCheckboxButtonNames.forEach(name => {
    let fields = Array.from(document.querySelectorAll('input[name="' + name + '"]'))
    fields.forEach(field => {
      if (fieldsArray.includes(field)) {
        let required = field.required = true
        if( required ) {
          if(!requiredRadioCheckboxButtonArrays.includes(name)) {
            requiredRadioCheckboxButtonArrays.push(name)
          }
        }
      }
    }
    )
  })

  let unsuccesfulRadioCheckboxArrays = requiredRadioCheckboxButtonArrays.filter(button => !checkedRadioCheckboxButtonNames.includes(button))

  if (unsuccesfulRadioCheckboxArrays.length > 0 || requiredOtherFields.length > 0) {
    console.error('Some Radio Buttons, Text Fields or Checkboxes are required but not checked or filled out')
    return false
  } else {
    return true
  }
}

/*
  #ANCHOR Get Field Values from Modal
*/ 

const oxgGetFieldValuesFromModal = (modal)=> {
  let fieldValues = []
  let additionalInfoValues = []
  let fields = modal.querySelectorAll('input')
  let textareas = modal.querySelectorAll('textarea')
  if(!fields) return
  fields.forEach(field => {
    let type = field.getAttribute('type')
    let optionName = field.getAttribute('data-option-name')
    let isInactive = field.getAttribute('data-is-inactive') ? field.getAttribute('data-is-inactive') : false

    if (isInactive != 'true') { 
      if ( type == 'checkbox' || type == 'radio') {
        if(field.checked) {
          fieldValues.push({
            inputFieldType: type,
            optionName: optionName,
            value: field.value,
          })
        }
      } else if ( type == 'hidden' ) {
        if(field.value !== null && field.value !== undefined) {
          fieldValues.push({
            inputFieldType: type,
            optionName: optionName,
            value: field.value,
          })
        }
      } else if ( type == 'text' || type == 'number' ) {
        if(field.value !== null && field.value !== undefined) {
          fieldValues.push({
            inputFieldType: type,
            optionName: optionName,
            value: field.value,
          })
        }
      }
    }
  })
  textareas.forEach(textarea => {
    let isInactive = textarea.getAttribute('data-is-inactive') ? textarea.getAttribute('data-is-inactive') : false
    let optionName = textarea.getAttribute('data-option-name')
    console.log('textarea option', optionName)
    if (isInactive != 'true' && textarea.value && textarea.value != '') {
      console.log('is active and not empty')
      fieldValues.push({
        inputFieldType: 'textarea',
        optionName: optionName,
        value: textarea.value,
      })
    } else {
      console.log('is inactive or empty')
    }
  })
  return fieldValues
}

/*
  #ANCHOR Get Add. Field Values from Modal
*/ 

const oxgGetAdditionalInfosFromModal = (modal)=> {
  let additionalInfos = []
  let textareas = modal.querySelectorAll('textarea')
  let infos = modal.querySelector('.asset-info')
  let infoItems = infos.querySelectorAll('.item')
  if(!infoItems) return
  infoItems.forEach(item => {
    let name = item.querySelector('.item-name').innerText
    let value = item.querySelector('.item-value').innerText
    additionalInfos.push({
      name: name,
      value: value,
    })
  })
  return additionalInfos
}

/*
  #ANCHOR Update & Sync
*/

//writes a value to a keyname in oxgAssetBriefingItems & updates session meta and briefing form
const updateAndSync = (fieldValue, keyName, syncForm = true, updateSessionMetaSession = true, updateMainSession = false)=> {
  if (fieldValue && fieldValue.trim().length === 0) { fieldValue = null }

  console.log('updateAndSync', fieldValue, keyName);
  console.log('oxgAssetBriefingItems', oxgAssetBriefingItems, typeof oxgAssetBriefingItems)
  if(!fieldValue) return;
  let existingKeyName = oxgAssetBriefingItems.find(obj => obj.hasOwnProperty(keyName))
  if (existingKeyName) {
    console.log('keyName ' + keyName + ' already exists. Updating...')
    existingKeyName[keyName] = fieldValue
  } else {
    console.log('keyName ' + keyName + ' doesnt exists. Creating it...')
    let newItem = {};
    newItem[keyName] = fieldValue
    oxgAssetBriefingItems.push(newItem)
  }

  if( syncForm ) {
    syncBriefingForm()
  }

  if( updateSessionMetaSession ) {
    updateSessionMeta(keyName, fieldValue)
  }

  if ( updateMainSession ) {
    updateSessionMain()
  }
}

/*
  #ANCHOR Update Session Main
  Writes oxgAssetBriefingItems into hidden briefing field
*/ 

const updateSessionMain = ()=> {
  sessionStorage.setItem('oxgAssetBriefingItems', JSON.stringify(oxgAssetBriefingItems))
}

/*
  #ANCHOR Update Session Meta 
  Updates oxgAssetBriefingMeta in var and session
*/ 

const updateSessionMeta = (keyName, value)=> {
  oxgAssetBriefingMeta[keyName] = value
  sessionStorage.setItem('oxgAssetBriefingMeta', JSON.stringify(oxgAssetBriefingMeta))
}

/*
  #ANCHOR Sync Briefing Form
  Writes oxgAssetBriefingItems into hidden briefing field
*/ 

const syncBriefingForm = ()=> {
  let assetsField = document.getElementById('briefing-assets')
  assetsField.value = JSON.stringify(oxgAssetBriefingItems)
}

/*
  #ANCHOR Update Current Save Info
  oxgAssetBriefingCurrentSave is used to determine if the currently edited briefing has already been saved previously
*/ 

const updateOxgAssetBriefingCurrentSave = (options = {
    isActive: false, 
    saveName: null, 
    oxgId: null, 
    unsavedChanges: false, 
    teamId: false,
    updateSessionItem: true})=> {
      console.log('updateOxgAssetBriefingCurrentSave')
  oxgAssetBriefingCurrentSave.isActive = options.isActive && typeof options.isActive == 'boolean' ? options.isActive : false
  oxgAssetBriefingCurrentSave.saveName = options.saveName && typeof options.saveName == 'string' ? options.saveName : null
  oxgAssetBriefingCurrentSave.oxgId = options.oxgId && typeof options.oxgId == 'string' ? options.oxgId : null
  oxgAssetBriefingCurrentSave.unsavedChanges = options.unsavedChanges && typeof options.unsavedChanges == 'boolean' ? options.unsavedChanges : false
  oxgAssetBriefingCurrentSave.teamId = options.teamId && typeof options.teamId == 'string' ? options.teamId : false
  if( options.updateSessionItem ) { writeOxgAssetBriefingCurrentSaveToSession() }
}

const writeOxgAssetBriefingCurrentSaveToSession = ()=> {
  console.log('writeOxgAssetBriefingCurrentSaveToSession')
  sessionStorage.setItem('oxgAssetBriefingCurrentSave', JSON.stringify(oxgAssetBriefingCurrentSave))
}

const updateOxgAssetBriefingCurrentSaveFromSession = ()=> {
  console.log('updateOxgAssetBriefingCurrentSaveFromSession')
  let parsedFromSession = getCurrentSaveInfoFromSession()
  oxgAssetBriefingCurrentSave = parsedFromSession
}

const getCurrentSaveInfoFromSession = ()=> {
  console.log('getCurrentSaveInfoFromSession')
  let sessionItem = sessionStorage.getItem('oxgAssetBriefingCurrentSave')
  if(!sessionItem) return
  let parsedFromSession = JSON.parse(sessionItem)
  if(!parsedFromSession) return
  return parsedFromSession 
}

/*
  #ANCHOR Date Pickers Init
*/

const oxgDatePickersInit = (selectorDOMNode)=> {
  console.log('date pickers init', selectorDOMNode)
  oxgInitDatepicker(selectorDOMNode)
}

const oxgInitDatepicker = (selectorDOMNode)=> {
  oxgDatepickers = datepicker(selectorDOMNode, {
    alwaysShow: false,
    closeAfterSelect: true,
    minDate: new Date(),
    noWeekends: true,
    formatter: (input, date, instance) => {
      const value = date.toLocaleDateString()
      input.value = value // => '1/1/2099'
    },
    startDay: 1,
    customDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    customMonths: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    customOverlayMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    overlayPlaceholder: '4-stellige Jahreszahl',
    showAllDates: true,
    overlayButton: "Okay",
    startDate: oxgGetTodayPlusDays(14),
    onSelect: (instance, date) => {
      let field = instance.el
      let fieldResponseContainer = field.parentNode.querySelector('.field-response-container')
      let isMainDeadline = false
      if (field.getAttribute('id') == 'briefing-deadline') {
        isMainDeadline = true
      }
      checkDeadlineField(field, fieldResponseContainer, {date: date, context: 'js-datepicker', mainDeadline: isMainDeadline})
    },
  })
  oxgDatepickers.calendarContainer.style.setProperty('font-size', '1.875rem')
  oxgDatepickers.toggleOverlay()
}

//#!SECTION

/*
  #SECTION File Upload
*/ 

/*
  #ANCHOR Listen File Selection
*/ 

const oxgListenForFileSelection = (modal) => {
  let fileUploadField = modal.querySelector('.field-file')
  let fileNameField = modal.querySelector('.field-file-name')
  fileUploadField.addEventListener('change', function(e) {
    const theFile = e.target.files[0];
    const feedbackContainer = modal.querySelector('.file-field-message')
    const feedback = modal.querySelector('.file-field-message-text')
    let positiveFeedback = feedback.getAttribute('data-valid-text')
    let negativeFeedback = feedback.getAttribute('data-invalid-text')
    let fileSizeLimitFeedback = feedback.getAttribute('data-filesize-limit-text')
    let inProgress = modal.querySelector('.upload-in-progress')
    if (theFile) {

      const allowedTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/zip',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // PPTX
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // XLSX
      ];

      if (!allowedTypes.includes(theFile.type)) {
        e.target.value = ''
        feedback.textContent = negativeFeedback
        feedbackContainer.classList.remove('is-hidden', 'style-success')
        feedbackContainer.classList.add('style-danger')
        return
      } 

      const maxSize = 200 * 1024 * 1024; // 200MB
      if (theFile.size > maxSize) {
        e.target.value = ''
        feedback.textContent = fileSizeLimitFeedback
        feedbackContainer.classList.remove('is-hidden', 'style-success')
        feedbackContainer.classList.add('style-danger')
        return
      }

      //upload file
      oxgUploadFileDirect(theFile, inProgress, feedbackContainer, feedback, modal, fileUploadField)

      /* feedback.textContent = positiveFeedback
      feedbackContainer.classList.remove('is-hidden', 'style-danger')
      feedbackContainer.classList.add('style-success')  */
    }
  })
}

/*
  #ANCHOR Remove selected Files
*/ 

const oxgRemoveAnySelectedFiles = (modal) => {
  let fileUploadFiled = modal.querySelector('.field-file')
  const feedbackContainer = modal.querySelector('.file-field-message')
  const feedback = modal.querySelector('.file-field-message-text')
  fileUploadFiled.value = ''
  feedbackContainer.classList.add('is-hidden')
  feedback.textContent = ''
}

/*
  #ANCHOR Reset Upload Field
*/

window.oxgResetAssetUploadFileField = (link) => {
  let modalId = link.getAttribute('data-target-modal')
  let modal = document.getElementById('modal-box-' + modalId)
  if(!modal) return
  let uploadField = modal.querySelector('.field-file')
  let selectedFileInfo = modal.querySelector('.selected-file-info')
  let selectedFileInfoText = selectedFileInfo.querySelector('.text')
  let fieldFileName = modal.querySelector('.field-file-name')
  if (!uploadField || !selectedFileInfo || !selectedFileInfoText || !fieldFileName) return
  uploadField.value = ''
  uploadField.classList.remove('is-hidden')
  selectedFileInfo.classList.add('is-hidden')
  selectedFileInfoText.innerText = ''
  oxgRemovePreviouslyUploadedFile(fieldFileName.value)
  fieldFileName.value = '';
}

/*
  #ANCHOR Delete Uploaded File
*/

const oxgRemovePreviouslyUploadedFile = (fileName) => {
  fetch(window.location.origin + '/wp-content/themes/bricks-child/includes/project/asset-versions/asset-file-delete.php', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({ file_name: fileName }),
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
        //alert(data.success);
        // Optionally, you can also remove the image from the DOM or perform other actions
    } else {
        //alert(data.error);
    }
  })
  .catch(error => {
    console.error('Fetch error:', error);
    alert('An error occurred while deleting the file.');
  });
};


/*
  #ANCHOR Upload File
*/

const oxgUploadFileDirect = (file, inProgress, feedbackContainer, feedback, modal, fileUploadField)=> { 
  let uniqueFileName = null
  let assetPostId = modal.querySelector('.asset-version').getAttribute('data-asset-id')
  let hiddenFileNameField = modal.querySelector('#oxg-uploaded-file-name-' + assetPostId)
  let selectedFileInfo = modal.querySelector('.selected-file-info')
  let selectedFileInfoText = selectedFileInfo.querySelector('.text')
  let switchFilesLink = selectedFileInfo.querySelector('.switch-file-link')
  let fileTypeInfo = modal.querySelector('.filetype-info')
  const formData = new FormData();
  formData.append('asset-file', file);

  inProgress.classList.add('is-hidden')

  let htmlTag = document.getElementsByTagName('html')
  let language = htmlTag[0].getAttribute('lang')

  fetch(window.location.origin + '/wp-content/themes/bricks-child/includes/project/asset-versions/asset-file-upload.php', {
    method: 'POST',  
    /* headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Language': language
    },*/ 
    body: formData
  })
  .then(inProgress.classList.remove('is-hidden'))
  .then(response => {
    if (!response.ok) {
      return response.text().then(text => { throw new Error(text) });
    }
    return response.json();
  })
  .then(data => {
    // Handle success (store file reference, navigate to next page, etc.)

    //update hidden field
    hiddenFileNameField.value = data.fileName;

    //hide upload field and show selected file info
    let fieldFileName = modal.querySelector('.field-file-name')
    fieldFileName.value = data['fileName']
    fileUploadField.classList.add('is-hidden')
    fileTypeInfo.classList.add('is-hidden')
    selectedFileInfo.classList.remove('is-hidden')
    selectedFileInfoText.innerText = file.name

    //feedback message
    feedback.textContent = data['message']
    feedbackContainer.classList.remove('is-hidden', 'style-danger')
    feedbackContainer.classList.add('style-success')
    inProgress.classList.add('is-hidden')
    //window.location.href = '/next-page-url'; // Navigate to the next page
  })
  .catch(error => {
    // Handle error
    console.error('Error uploading file', error.error);
    feedback.textContent = error['error']
    feedbackContainer.classList.remove('is-hidden', 'style-success')
    feedbackContainer.classList.add('style-danger')
    inProgress.classList.add('is-hidden')
 });

 return uniqueFileName
 
}

//#!SECTION

/*
  #SECTION Submission Step 1
*/ 

/*
  #ANCHOR Check Briefing Form 
*/ 

const oxgBriefingFormCheck = ()=> {
  let briefingTitle = document.getElementById('briefing-title')
  let briefingDeadline = document.getElementById('briefing-deadline')
  if( briefingTitle && briefingDeadline ) {
    let title = !briefingTitle.value || briefingTitle.value == '' || briefingTitle == ' ' ? false : true
    let feed = oxgAssetBriefingItems && oxgAssetBriefingItems.some(obj => obj.hasOwnProperty('assetPostId')) ? true : false
    let deadline
    let mainDeadlineNeeded = oxgCheckIfDeadlineNeeded()
    if(mainDeadlineNeeded) {
      deadline = !briefingDeadline.value ? false : true
    } else {
      deadline = true
    }
    return {
      successful: title && deadline && feed ? true : false,
      title: title,
      deadline: deadline,
      feed: feed,
    }
  } else {
    console.error('Missing fields in briefing form. Check not completed.')
    return false
  }
}

/*
  #ANCHOR Is Main Deadline needed?
*/

const oxgCheckIfDeadlineNeeded = ()=> {
  if (!oxgAssetBriefingItems || !Array.isArray(oxgAssetBriefingItems) || oxgAssetBriefingItems.length == 0) return true
  let numItemsInCart = oxgAssetBriefingItems.length
  let itemsWithDeadline = 0
  oxgAssetBriefingItems.forEach(itemInCart => {
    if ( !itemInCart.hasOwnProperty("assetPostId") ) {
      // Auto increase count if item is not an asset
      itemsWithDeadline++
    } else if (itemInCart.hasDeadline) {
      // If asset, increase if has deadline
      itemsWithDeadline++
    }
  })
  if (numItemsInCart == itemsWithDeadline) {
    return false
  } else {
    return true
  }
}

/*
  #ANCHOR Check Briefing Deadline (Step 1)
*/

const oxgCheckBriefingDeadline = (givenDate)=> {
  console.log(givenDate)
  let daysUntil = oxgGetDaysUntil(givenDate)
  console.log('daysUntil', daysUntil)
  if(daysUntil) {
    if(daysUntil == 'missing') {
      return 'missing'
    } else if(daysUntil == 'invalid') {
      return 'invalid'
    } else if ( daysUntil < 0 ) {
      return 'past'
    } else if(daysUntil < 14 || daysUntil == 'today') {
      return 'warning'
    } else {
      return 'optimal'
    }
  } else {
    return 'missing'
  }
}

/*
  #ANCHOR Check Deadline
*/

const checkDeadlineField = (field, fieldContextContainer, args = null) => {
  console.log(field, fieldContextContainer, theDate)
  let removeLink = fieldContextContainer.querySelector('.remove-deadline-link')
  let uf = null
  let theDate = args && args.date ? args.date : null
  let context = args && args.context ? args.context : 'init'
  let clearPastDate = args && args.clearPastDate ? args.clearPastDate : true

  var performCheck = ()=> {
    let date = theDate ? theDate : field.value
    let check = oxgCheckBriefingDeadline(date)
    oxgRemoveUfsFromContainer(fieldContextContainer)
    if(['optimal', 'warning'].includes(check) && args.mainDeadline) {
      //updateAndSync(field.value, 'deadline')
      updateSessionMeta('deadline', field.value)
    } else {
      if ( args.mainDeadline ) {
        //updateAndSync(null, 'deadline')
        updateSessionMeta('deadline', null)
      }
    }
    if(check == 'optimal') {
      console.log('check optimal')
      removeLink ? removeLink.classList.remove('is-hidden') : null
    } else if (check == 'missing') {
      uf = oxgCreateUf({
        format: 'text',
        icon: 'exclamation-mark--circled',
        style: 'danger',
        message: 'Give this briefing a deadline',
        messageDe: 'Gib diesem Briefing eine Deadline',
        container: fieldContextContainer,
        classes: ['m-xs-top'],
        return: true,
      })
      removeLink ? removeLink.classList.add('is-hidden') : null
    } else if (check == 'warning') {
      uf = oxgCreateUf({
        format: 'text',
        icon: 'exclamation-mark--circled',
        style: 'info',
        message: 'This is short notice but we will do our best! Additional costs or delays may encure. You can continue.',
        messageDe: 'Das ist etwas kurzfristig aber wir geben unser Bestes! Zusätzliche Kosten oder Verzögerungen könnten entstehen. Du kannst weitermachen.',
        container: fieldContextContainer,
        classes: ['m-xs-top'],
        return: true,
      })
      removeLink ? removeLink.classList.remove('is-hidden') : null
    } else if (check == 'invalid') {
      field.value = ''
      uf = oxgCreateUf({
        format: 'text',
        icon: 'exclamation-mark--circled',
        style: 'danger',
        message: 'Date invalid. Format: dd.mm.yyyy',
        messageDe: 'Datum ungültig. Format: TT.MM.YYYY',
        container: fieldContextContainer,
        classes: ['m-xs-top'],
        return: true,
      })
      removeLink ? removeLink.classList.add('is-hidden') : null
      setTimeout(function() {
        uf.remove()
      }, 3000)
    } else if (check == 'past') {
      uf = oxgCreateUf({
        format: 'text',
        icon: 'exclamation-mark--circled',
        style: 'danger',
        message: 'Date must be in the future',
        messageDe: 'Datum muss in der Zukunft liegen',
        container: fieldContextContainer,
        classes: ['m-xs-top'],
        return: true,
      })
      removeLink ? removeLink.classList.add('is-hidden') : null
      if (clearPastDate) {
        field.value = ''
      }
      setTimeout(function() {
        uf.remove()
      }, 3000)
    }
  }

  if (context == 'init') {
    field.addEventListener('change', ()=> {
      performCheck()
    })
  } else if (context == 'js-datepicker') {
    performCheck()
  }

  if(removeLink) {
    removeLink.addEventListener('click', (e)=> {
      e.preventDefault()
      field.value = ''
      oxgRemoveUfsFromContainer(fieldContextContainer)
      updateSessionMeta('deadline', null)
      removeLink.classList.add('is-hidden')
    })
  }

}

/*
  #ANCHOR Next Button Step 1
*/

const oxgNextButtonStep1 = (nextButton) => {
  let assetBriefingFeedEmpty = document.getElementById('briefing-feed-empty-container')
  let sidebarFeedResponseContainer = assetBriefingFeedEmpty.querySelector('.sidebar-feed-response')
  let briefingForm = document.getElementById('briefing-form')
  let briefingTitle = document.getElementById('briefing-title')
  let briefingTitleResponseContainer = briefingTitle.parentNode.querySelector('.field-response-container')
  let briefingDeadline = document.getElementById('briefing-deadline')
  let briefingDeadlineResponseContainer = briefingForm.querySelector('.deadline-context-items')

  checkDeadlineField(briefingDeadline, briefingDeadlineResponseContainer, {mainDeadline: true})

  document.addEventListener('oxgAssetAddedToSidebar', (e)=> {
    nextButton.classList.remove('deactivated')
    oxgRemoveUfsFromContainer(sidebarFeedResponseContainer)
  })

  document.addEventListener('oxgAssetRestoredToSidebarFromSession', (e) => {
    nextButton.classList.remove('deactivated')
    oxgRemoveUfsFromContainer(sidebarFeedResponseContainer)
  })

  document.addEventListener('assetDeletedFromSidebar', (e)=> {
    if(oxgAssetBriefingItems && oxgAssetBriefingItems.some(obj => obj.hasOwnProperty('assetPostId')) == 0) {
      nextButton.classList.add('deactivated')
      showSidebarEmptyUf()
      if (oxgAssetBriefingPage == 1) {
        // If page 1 and no items, deadline or title in sidebar, set unsaved changes to false
        if (!oxgAssetBriefingMeta.deadline && !oxgAssetBriefingMeta.title) {
          oxgAssetBriefingCurrentSave.unsavedChanges = false
          writeOxgAssetBriefingCurrentSaveToSession()
        }
      }
    }
  })

  briefingTitle.addEventListener('change', ()=> {
    if (briefingTitle.value && briefingTitle.value != '' && briefingTitle != ' ') {
      briefingTitle.value = oxgReplaceUrlParametersInString(briefingTitle.value)
      updateSessionMeta('title', briefingTitle.value)
      oxgRemoveUfsFromContainer(briefingTitleResponseContainer)
    } else {
      updateSessionMeta('title', null)
    }
  })

  briefingDeadline.addEventListener('change', ()=> {
    console.log('briefig deadline field change')
    if (briefingDeadline.value && briefingDeadline.value != '' && briefingDeadline != ' ') {
      updateSessionMeta('deadline', briefingDeadline.value)
      oxgRemoveUfsFromContainer(briefingDeadlineResponseContainer)
    } else {
      updateSessionMeta('deadline', null)
    }
  })

  nextButton.addEventListener('click', (e)=> {
    e.preventDefault()
    let check = oxgBriefingFormCheck()
    console.log(check)
    if( check.successful ) {
      console.log('briefing form submit')
      briefingForm.submit()
      //window.open(window.location.origin + '/asset-briefing-2')
    } else {
      if (!check.title) {
        let ufTitle = oxgCreateUf({
          message: 'Give this briefing a name',
          messageDe: 'Gib diesem Briefing einen Namen',
          icon: 'exclamation-mark--circled',
          style: 'danger',
          container: briefingTitleResponseContainer,
          format: 'text',
          classes: ['m-xs-top'],
          return: true,
        })
        setTimeout(function() {
          ufTitle.remove()
        }, 3000)
        briefingTitle.focus()
      }
      if (!check.deadline) {
        let ufDeadline = oxgCreateUf({
          format: 'text',
          icon: 'exclamation-mark--circled',
          style: 'danger',
          message: 'Give this briefing a deadline',
          messageDe: 'Gib diesem Briefing eine Deadline',
          container: briefingDeadlineResponseContainer,
          classes: ['m-xs-top'],
          return: true
        })
        setTimeout(function() {
          ufDeadline.remove()
        }, 3000)
      }

      if (!check.feed) {
        showSidebarEmptyUf()
      }
    }
  })
}

const showSidebarEmptyUf = ()=> {
  let mainContainer = document.getElementById('briefing-feed-empty-container')
  let responseContainer = mainContainer.querySelector('.sidebar-feed-response')
  oxgRemoveUfsFromContainer(responseContainer)
  let ufFeedEmpty = oxgCreateUf({
    format: 'box',
    icon: 'exclamation-mark--circled',
    style: 'danger',
    message: 'Add one or more assets to this briefing.',
    messageDe: 'Füge mindestens ein Asset zu diesem Briefing hinzu.',
    container: responseContainer,
    classes: ['omit-m-top', 'm-xxs-bottom'],
    return: true,
  })
}

window.oxgDoPriceEstimation = ()=> {
  oxgAssetBriefingPriceEst()
}

//#!SECTION

/*
  #ANCHOR Init
*/ 

const initPage1 = ()=> {
  oxgAssetBriefingPage = 1;
  //next button
  let assetBriefingNext1 = document.getElementById('asset-briefing-next-button-1')
  if(assetBriefingNext1) {oxgNextButtonStep1(assetBriefingNext1)}
  //session
  oxgContinueSession()
  //datepickers
  let initialDatepickers = document.querySelectorAll('.oxg-datepicker')
  if (initialDatepickers) {oxgDatePickersInit('.oxg-datepicker')}
  //event
  let assetBriefingJsEvent = new Event('assetBriefingJsLoaded')
  document.dispatchEvent(assetBriefingJsEvent)
}

const initPage2 = ()=> {
  oxgAssetBriefingPage = 2;
  // Price estimation
  oxgDoPriceEstimation();
  //next button
  let assetBriefingNext1 = document.getElementById('asset-briefing-next-button-1')
  if(assetBriefingNext1) {oxgNextButtonStep1(assetBriefingNext1)}
  //session
  oxgContinueSession()
  //datepickers
  let initialDatepickers = document.querySelectorAll('.oxg-datepicker')
  if (initialDatepickers) {oxgDatePickersInit('.oxg-datepicker')}
  //event
  let assetBriefingJsEvent = new Event('assetBriefingJsLoaded')
  document.dispatchEvent(assetBriefingJsEvent)
  // Main Description
  let mainDescriptionField = document.getElementById('briefing-main-description')
  if (!mainDescriptionField.value) {
    if(oxgAssetBriefingMeta && oxgAssetBriefingMeta.comment) {
      mainDescriptionField.value = oxgAssetBriefingMeta.comment
    }
  }
  mainDescriptionField.addEventListener('change', ()=> {
    let value = mainDescriptionField.value
    if (value) {
      updateSessionMeta('comment', value)
    } else {
      updateSessionMeta('comment', null)
    }
    oxgAssetBriefingCurrentSave.unsavedChanges = true
    writeOxgAssetBriefingCurrentSaveToSession()
  })
  // Team ID
  let briefingTeamIdField = document.getElementById('briefing-team-id')
  if (oxgAssetBriefingCurrentSave.teamId) {
    briefingTeamIdField.value = oxgAssetBriefingCurrentSave.teamId
  } else {
    oxgAssetBriefingCurrentSave.teamId = briefingTeamIdField.value
    writeOxgAssetBriefingCurrentSaveToSession()
  }
  briefingTeamIdField.addEventListener('change', ()=> {
    let value = briefingTeamIdField.value
    if (value) {
      oxgAssetBriefingCurrentSave.teamId = value
    } else {
      oxgAssetBriefingCurrentSave.teamId = true
    }
    oxgAssetBriefingCurrentSave.unsavedChanges = true
    writeOxgAssetBriefingCurrentSaveToSession()
  })
  // Briefing Substitute
  let substituteInfo = []
  let substituteEmail = document.getElementById('substitute-email')
  let substitutePhone = document.getElementById('substitute-phone')
  substituteInfo.push(document.getElementById('substitute-name'))
  substituteInfo.push(substituteEmail)
  substituteInfo.push(substitutePhone)
  let substituteEmailResponseContainer = substituteEmail.parentNode.querySelector('.field-response-container')
  let substitutePhoneResponseContainer = substitutePhone.parentNode.querySelector('.field-response-container')
  substitutePhone.addEventListener('keyup', (e)=> {
    // Autocorrect Phone Numbers to valid format that can be checked by parsePhoneNumberFromString without requiring a country code like 'DE'
    substitutePhone.value = oxgAutoCorrectPhoneNumber(substitutePhone.value, e)
  })
  substituteInfo.forEach(field => {
    field.addEventListener('change', ()=> {
      let id = field.id
      if(id == 'substitute-name') {
        updateSessionMeta('substitute_name', field.value)
      } else if ( id == 'substitute-email' ) {
        let isValidEmail = oxgIsValidEmail(field.value)
        if(!isValidEmail) {
          field.value = null
          oxgRemoveUfsFromContainer(substituteEmailResponseContainer)
          uf = oxgCreateUf({
            format: 'text',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'Enter a valid email address.',
            messageDe: 'Gib eine gültige E-Mail Adresse an.',
            container: substituteEmailResponseContainer,
            classes: ['omit-m-top', 'm-s-bottom'],
            return: true,
          })
        } else {
          oxgRemoveUfsFromContainer(substituteEmailResponseContainer)
          updateSessionMeta('substitute_email', field.value)
        }
      } else if ( id == 'substitute-phone' ) {
        if(field.value) {
          let isPhoneNumberValid = parsePhoneNumberFromString(field.value)
          if(!isPhoneNumberValid) {
            field.value = null
            oxgRemoveUfsFromContainer(substitutePhoneResponseContainer)
            uf = oxgCreateUf({
              format: 'text',
              icon: 'exclamation-mark--circled',
              style: 'danger',
              message: 'Enter a valid phone number.',
              messageDe: 'Gib eine gültige Telefonnummer an.',
              container: substitutePhoneResponseContainer,
              classes: ['omit-m-top', 'm-s-bottom'],
              return: true,
            })
          } else {
            oxgRemoveUfsFromContainer(substitutePhoneResponseContainer)
            updateSessionMeta('substitute_phone', field.value)
          }
        }
      }
    })
  })
  // Briefing Team ID
  let briefingTeamId = document.getElementById('briefing-team-id')
  if (briefingTeamId) {
    updateSessionMeta('team_id', briefingTeamId.value)
    briefingTeamId.addEventListener('change', ()=> {
      updateSessionMeta('team_id', briefingTeamId.value)
    })
  }
}

const updateAssetBriefingItemsTitle = ()=> {
  /**
   * Update title in oxgAssetBriefingItems. The deadline 
   * value in oxgAssetBriefingItems is updated using 
   * js-datepicker and checkDeadlineField()
  */
  let titleField = document.getElementById('briefing-title')
  if (titleField && titleField.tagName == 'INPUT') {
    titleField.addEventListener('change', ()=> {
      if(titleField.value && titleField.value != '') {
        titleField.value = oxgReplaceUrlParametersInString(titleField.value)
      }
      //updateAndSync(titleField.value, 'title')
      updateSessionMeta('title', titleField.value)
    })
  }
}

document.addEventListener('DOMContentLoaded', () => { 
  if (document.body.classList.contains('ab1')) {
    initPage1()
    updateAssetBriefingItemsTitle()
  } else if( document.body.classList.contains('ab2') ) {
    initPage2()
    updateAssetBriefingItemsTitle()
  }  
})